<template>
	<div>
		<div class="container">
			<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
				<el-tab-pane label="企业数据" name="company">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isSubAgent" v-model="query.subAgentId"
							@change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
							class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px" v-model="query.companyId" filterable clearable
							placeholder="企业" class="handle-select mr10">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 120px" v-if="isAdmin || isagent"
							v-model="query.businessType" filterable clearable placeholder="企业类型"
							class="handle-select mr10">
							<el-option v-for="item in businessTypeList" :key="item" :label="item"
								:value="item"></el-option>
						</el-select>

						<el-select size="small" style="width: 120px" v-if="isAdmin || isagent" v-model="query.status"
							filterable clearable placeholder="审核状态" class="handle-select mr10">
							<el-option v-for="item in statusList" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 120px" v-model="query.filtration" filterable clearable
							placeholder="过滤方式" class="handle-select mr10">
							<el-option v-for="item in filtrationList" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-cascader v-model="query.protectionLevel" :options="protectionLevel" @change="handleChange1"
							size="small" :disabled="protectionLevelTrue" style="margin-right: 10px;"
							v-if="query.filtration=='dhb'"></el-cascader>
						<el-select size="small" style="width: 120px" v-if="query.filtration=='yx'"
							v-model="query.yxLevel" filterable clearable placeholder="请选择御鑫等级"
							class="handle-select mr10" @change="yxLevelChang2">
							<el-option label="一级" :value="1">一级</el-option>
							<el-option label="二级" :value="2">二级</el-option>
							<el-option label="三级" :value="3">三级</el-option>
							<el-option label="四级" :value="4">四级</el-option>
							<el-option label="五级" :value="5">五级</el-option>
						</el-select>
						<el-select size="small" style="width: 120px" v-if="isAdmin || isagent" v-model="query.enable"
							filterable clearable placeholder="是否合作" class="handle-select mr10">
							<el-option label="是" value="true"></el-option>
							<el-option label="否" value="false"></el-option>
						</el-select>
						<el-select size="small" style="width: 120px" v-if="isAdmin || isagent" v-model="query.locked"
							filterable clearable placeholder="是否锁定" class="handle-select mr10">
							<el-option label="是" value="true"></el-option>
							<el-option label="否" value="false"></el-option>
						</el-select>
						<el-input size="small" v-model="query.companyName" clearable placeholder="请输入公司名称" class="mr10"
							style="width: 180px;" v-if="query.enable == 'false'"></el-input>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="handleSearch">搜索</el-button>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload2"
							@click="handleExport" v-if="isAdmin|| isagent">导出</el-button>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-goods" @click="getLock"
							v-if="isAdmin">锁定</el-button>
						<el-button size="small" type="primary" :class="[theme]" class="m_t_10"
							@click="showCompanyBatchSystemInterception">批量设置</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click="showRatingForm"
							class="m_t_10">手动评级</el-button>
						<el-button size="small" v-if="canAddCompany" type="primary" :class="[theme]" @click="showForm"
							class="m_t_10">添加企业</el-button>
					</div>
					<el-table :data="tableData" :border='true' class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange"
						style="width: 100%;" :key="tableKey">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agentName" width="220" label="代理商" align="center"
							v-if="!query.agentId&&isAdmin"></el-table-column>
						<el-table-column prop="name" width="220" label="企业" align="center"></el-table-column>
						<el-table-column prop="status" width="120" label="审核状态" align="center" v-if="isagent||isAdmin">
							<template #default="scope">
								<el-tag type="warning" v-if="scope.row.status=='待审核'"
									size="small">{{scope.row.status}}</el-tag>
								<el-tag type="danger" v-if="scope.row.status=='审核失败'"
									size="small">{{scope.row.status}}</el-tag>
								<el-tag type="primary" v-if="scope.row.status=='审核通过'"
									size="small">{{scope.row.status}}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="classification" label="企业等级" align="center" width="80"></el-table-column>
						<!-- <el-table-column prop="businessType" label="企业类型" align="center"></el-table-column> -->
						<el-table-column prop="showProtectionLevel" label="电话邦业务类型" align="center" width="130">
							<template #default="scope">
								<div v-if="scope.row.filtration=='yx'||scope.row.filtration=='non'">
									<span class="red">{{scope.row.showProtectionLevel}}</span>
								</div>
								<div v-else>
									<span>{{scope.row.showProtectionLevel}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="yxLevel" label="御鑫业务类型" align="center" width="130">
							<template #default="scope">
								<div v-if="scope.row.filtration=='dhb'||scope.row.filtration=='non'">
									<span v-if="scope.row.yxLevel=='1'" class="red">一级</span>
									<span v-if="scope.row.yxLevel=='2'" class="red">二级</span>
									<span v-if="scope.row.yxLevel=='3'" class="red">三级</span>
									<span v-if="scope.row.yxLevel=='4'" class="red">四级</span>
									<span v-if="scope.row.yxLevel=='5'" class="red">五级</span>
								</div>
								<div v-else>
									<span v-if="scope.row.yxLevel=='1'">一级</span>
									<span v-if="scope.row.yxLevel=='2'">二级</span>
									<span v-if="scope.row.yxLevel=='3'">三级</span>
									<span v-if="scope.row.yxLevel=='4'">四级</span>
									<span v-if="scope.row.yxLevel=='5'">五级</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="filtration" label="过滤方式" align="center" width="160">
							<template #default="scope">
								<span v-for="(item,index) in scope.row.filtration.split(',')" :key="index">
									<el-tag class="m_l_10" v-if="item=='dhb'" size="small">电话邦</el-tag>
									<el-tag class="m_l_10" v-if="item=='yx'" size="small">御鑫</el-tag>
									<el-tag class="m_l_10" v-if="item=='non'" size="small">不过滤</el-tag>
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="highFrequency" label="高频范围" align="center" v-if="isAdmin || isagent"
							width="100">
							<template #default="scope">
								<el-switch v-model="scope.row.highFrequency" active-color="#13ce66"
									inactive-color="#ff4949" disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="blacklist" label="共享黑名单" align="center" v-if="isAdmin || isagent"
							width="100">
							<template #default="scope">
								<el-switch v-model="scope.row.blacklist" active-color="#13ce66" inactive-color="#ff4949"
									disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="riskNumber" label="共享风险号码" align="center" v-if="isAdmin || isagent"
							width="100">
							<template #default="scope">
								<el-switch v-model="scope.row.riskNumber" active-color="#13ce66"
									inactive-color="#ff4949" disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="locked" label="是否锁定" align="center" v-if="isAdmin">
							<template #default="scope">
								<el-switch v-model="scope.row.locked" active-color="#13ce66" inactive-color="#ff4949"
									@change="getLock2(scope.row)"></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="enable" label="是否合作" align="center" v-if="isAdmin || isagent">
							<template #default="scope">
								<el-switch v-model="scope.row.enable" active-color="#13ce66" inactive-color="#ff4949"
									@change="getswitchenable(scope.row)"></el-switch>
							</template>
						</el-table-column>
						<el-table-column prop="ownerName" label="企业联系人" align="center" width="130"></el-table-column>
						<el-table-column prop="ownerPhone" label="负责人联系电话" align="center" width="130"></el-table-column>
						<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
						<el-table-column label="操作" width="280" align="center" fixed="right">
							<template #default="scope">
								<el-button size="small" :disabled="canEditCompany" type="text" icon="el-icon-edit"
									@click="handleEdit(scope.$index, scope.row.id)">编辑</el-button>
								<el-button size="small" :disabled="canRemoveCompany" type="text" icon="el-icon-delete"
									style="color: #f56c6c;" @click="handleDelete(scope.$index, scope.row.id)">
									删除
								</el-button>
								<el-button size="small" type="text" v-if="isAdmin"
									@click="handleAudit(scope.row)">审核</el-button>
								<el-button size="small" v-if="isAdmin" type="text" @click="gtecompanyLvLog(scope.row)">
									拦截记录
								</el-button>
								<el-button size="small" v-if="isAdmin||isagent" type="text"
									@click="handleauditRecord(scope.row)">
									审核记录
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
							:page-size="query.pageSize" :total="pageTotal"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="在网数据" name="onTheInternet" v-if="isAdmin||isAgent">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query6.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isSubAgent" v-model="query6.subAgentId"
							@change="getfetchDefaultCompanies" filterable clearable placeholder="子代理"
							class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px" v-model="query6.companyId" filterable clearable
							placeholder="企业" class="handle-select mr10" v-if="isAgent">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query6.cardsId" filterable clearable placeholder="请选择品牌"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
								:value="item.label"></el-option>
						</el-select>
						<el-select size="small" v-model="query6.standard" clearable filterable placeholder="请选择制式"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in standardList" :key="item.label" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getcompanyUseData">搜索</el-button>
					</div>
					<div class="card-body fade-in" v-if="customDataTotal.totalCount">
						<div class="tit" :class="[theme]">
							<div><i class="fas fa-chart-bar el-icon-s-data"></i>在网数据</div>
						</div>
						<div class="card-list">
							<div class="card-item fade-in" :class="[theme7]">
								<span class="card-list-tit">在网</span>
								<span class="card-list-data">{{customDataTotal.totalCount||0}}</span>
							</div>
							<div class="card-item fade-in" :class="[theme7]" v-for="(item , index) in onlineList"
								:key="index">
								<div class="operator-item">
									<span class="card-list-tit">{{item.name}}</span>
									<span class="operator-value mobile-operator">{{item.total}}</span>
								</div>
								<div class="operator-item" v-for="(items , index) in item.subTab" :key="index">
									<span class="operator-label mobile-operator">{{items.label}}</span>
									<span class="operator-value mobile-operator">{{items.count||0}}</span>
								</div>
							</div>
						</div>
					</div>
					<el-table :data="tableData6" :border='true' class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange"
						style="width: 100%;" @row-click="showChildrens">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column align="center" label="终端" prop="name"></el-table-column>
						<el-table-column align="center" label="总在网" prop="total" sortable>
							<template #default="scope">
								<span style="border-bottom: 1px solid #878A93;">{{scope.row.total}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="item.name" v-for="item in onlineList" :key="item" align="center">
							<el-table-column v-for="j in item.subTab" :key="j.value" :label="j.label" :prop="j.value"
								align="center" sortable></el-table-column>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query6.pageIndex"
							:page-size="query6.pageSize" :total="pageTotal6"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>

				<el-tab-pane label="激活数据" name="onLineInternet" v-if="isAdmin||isAgent">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query12.agentId"
							filterable clearable placeholder="代理商" class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px" v-model="query12.companyId" filterable clearable
							placeholder="企业" class="handle-select mr10" v-if="isAgent">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query12.cardsId" filterable clearable placeholder="请选择品牌"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
								:value="item.label"></el-option>
						</el-select>
						<el-select size="small" v-model="query12.standard" clearable filterable placeholder="请选择制式"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in standardList" :key="item.label" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-date-picker v-model="timeArr2" type="daterange" unlink-panels range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime2" size="small"
							style="width: 260px;margin-right: 10px;"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getActivateRecordlist">搜索</el-button>
					</div>
					<div class="card-body fade-in" v-if="activateDataTotal.activateCount">
						<div class="tit" :class="[theme]">
							<div><i class="fas fa-chart-bar el-icon-s-data"></i>激活数据</div>
						</div>
						<div class="card-list">
							<div class="card-item fade-in" :class="[theme7]">
								<span class="card-list-tit">激活</span>
								<span class="card-list-data">{{activateDataTotal.activateCount||0}}</span>
							</div>
							<div class="card-item fade-in" :class="[theme7]" v-for="(item , index) in activateList"
								:key="index">
								<div class="operator-item">
									<span class="card-list-tit">{{item.name}}</span>
									<span class="operator-value mobile-operator">{{item.total}}</span>
								</div>
								<div class="operator-item" v-for="(items , index) in item.subTab" :key="index">
									<span class="operator-label mobile-operator">{{items.label}}</span>
									<span class="operator-value mobile-operator">{{items.count||0}}</span>
								</div>
							</div>
						</div>
					</div>
					<el-table :data="tableData12" :border='true' class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange"
						style="width: 100%;">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column align="center" label="终端" prop="name"></el-table-column>
						<el-table-column align="center" label="激活" prop="total" sortable></el-table-column>
						<el-table-column :label="item.name" v-for="item in activateList" :key="item" align="center">
							<el-table-column v-for="j in item.subTab" :key="j.value" :label="j.label" :prop="j.value"
								align="center" sortable></el-table-column>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, prev, pager, next" :current-page="query12.pageIndex"
							:page-size="query12.pageSize" :total="pageTota12"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="激活明细" name="activationDetails" v-if="isAdmin||isAgent">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query13.agentId"
							filterable clearable placeholder="代理商" class="handle-select mr10" style="width: 260px;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" style="width: 260px" v-model="query13.companyId" filterable clearable
							placeholder="企业" class="handle-select mr10" v-if="isAgent">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query13.cardsId" filterable clearable placeholder="请选择品牌"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
								:value="item.label"></el-option>
						</el-select>
						<el-select size="small" v-model="query13.standard" clearable filterable placeholder="请选择制式"
							style="margin-right: 10px;width: 180px;">
							<el-option v-for="item in standardList" :key="item.label" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-date-picker v-model="timeArr2" type="daterange" unlink-panels range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime2" size="small"
							style="width: 260px;margin-right: 10px;"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getactivateInfo">搜索</el-button>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
							@click="exportData2">导出</el-button>
					</div>

					<el-table :data="tableData13" :border='true' class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange"
						style="width: 100%;">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column align="center" label="代理商" prop="agentName"></el-table-column>
						<el-table-column align="center" label="企业" prop="companyName"></el-table-column>
						<el-table-column align="center" label="号码" prop="phone"></el-table-column>
						<el-table-column align="center" label="品牌" prop="cardName" width="130"></el-table-column>
						<el-table-column align="center" label="制式" prop="standard" width="130"></el-table-column>
						<el-table-column align="center" label="时间" prop="createdAt" width="155"></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query13.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query13.pageSize" :total="pageTotal13" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="归属地分布" name="areasDistribution" v-if="isAdmin">
					<div class="map-container-box">
						<!-- <div class="header">
							<h1>中国省级出库分布图</h1>
						</div> -->
						<div class="map-content">
							<div class="map-container" :class="[theme]">
								<div id="map" ref="map">
									<div class="loading">正在加载地图数据...</div>
								</div>
							</div>
							<div class="sidebar">
								<div class="controls">
									<el-button class="btn" size="small" type="primary" :class="[theme]"
										icon="el-icon-refresh" @click="getqueryProvinceCity">
										重置视图
									</el-button>
									<el-button class="btn" size="small" type="primary" :class="[theme]"
										icon="el-icon-upload2" @click="getexportWarehouse">导出</el-button>
									<el-select size="small" v-model="mapcardsId" filterable clearable
										placeholder="请选择品牌" @change="getqueryProvinceCity2">
										<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
											:value="item.label"></el-option>
									</el-select>
								</div>
								<h3 :class="[theme3]">各省市出库量排名</h3>
								<div class="data-list">
									<div class="data-item" :class="[theme3]" v-for="item in dataList" :key="item.value"
										@click="getqueryProvinceCity3(item)">
										<span>{{item.name}}</span>
										<span>{{item.value}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="出库记录" name="outboundRecord" v-if="isAdmin ||isAgent">
					<div class="handle-box">
						<el-form label-width="80px">
							<div class="form-items-wrapper">
								<el-form-item label="代理商" v-if="isAdmin">
									<el-select v-model="query4.agentId" @change="agentChange" clearable filterable
										placeholder="请选择代理商" size="small" class="handle-input" style="width: 260px;">
										<el-option v-for="item in agents" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="企业" v-if="isAgent">
									<el-select v-model="query4.companyId" clearable filterable placeholder="请选择企业"
										size="small" class="handle-input" style="width: 260px;">
										<el-option v-for="item in companys" :key="item.value" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="号码">
									<el-input size="small" v-model="query4.phone" clearable filterable
										placeholder="请输入手机号码" style="width: 260px;"></el-input>
								</el-form-item>
								<el-form-item label="类型">
									<el-select size="small" v-model="query4.type" clearable filterable
										placeholder="请选择类型" style="width: 260px;">
										<el-option v-for="item in typeList" :key="item.label" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="地市">
									<el-select size="small" v-model="query4.city" clearable filterable
										placeholder="请选择地市" style="width: 260px;">
										<el-option v-for="item in cityList" :key="item.label" :label="item.city"
											:value="item.city"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="品牌">
									<el-select size="small" v-model="query4.cardId" clearable filterable
										placeholder="请选择品牌" style="width: 260px;" @change="getSetMealList">
										<el-option v-for="item in cardsList" :key="item.label" :label="item.value"
											:value="item.label"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="制式">
									<el-select size="small" v-model="query4.standard" clearable filterable
										placeholder="请选择制式" style="width: 260px;">
										<el-option v-for="item in standardList" :key="item.label" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="ICCID">
									<el-input size="small" v-model="query4.iccid" clearable filterable
										placeholder="请输入ICCID" style="width: 260px;"></el-input>
								</el-form-item>
								<el-form-item label="IMSI">
									<el-input size="small" v-model="query4.imsi" clearable filterable
										placeholder="请输入IMSI" style="width: 260px;"></el-input>
								</el-form-item>
								<el-form-item label="套餐">
									<el-select size="small" v-model="query4.setMealId" clearable filterable
										placeholder="请选择套餐" style="width: 260px;">
										<el-option v-for="item in setMealIdList" :key="item.label" :label="item.name"
											:value="item.id"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="激活">
									<el-select size="small" v-model="query4.activation" clearable filterable
										placeholder="是否激活" style="width: 260px;">
										<el-option v-for="item in activationList" :key="item.label" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="退卡">
									<el-select size="small" v-model="query4.back" clearable filterable
										placeholder="请选择是否退卡" style="width: 260px;">
										<el-option v-for="item in backList" :key="item.label" :label="item.label"
											:value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="批次号">
									<el-input size="small" v-model="query4.batchNum" clearable placeholder="请输入批次号"
										style="width: 260px;"></el-input>
								</el-form-item>
								<el-form-item label="操作人">
									<el-select size="small" v-model="query4.operator" clearable filterable
										placeholder="请选择操作人" style="width: 260px;">
										<el-option v-for="item in operatorList" :key="item.label" :label="item.operator"
											:value="item.operator"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="时间">
									<el-date-picker v-model="timeArr" type="daterange" unlink-panels range-separator="至"
										start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime" size="small"
										style="width: 260px;"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
										@click="getOutboundData">搜索</el-button>
									<el-button size="small" type="primary" :class="[theme]" icon="el-icon-download"
										@click="exportData">导出</el-button>
								</el-form-item>
							</div>
						</el-form>
					</div>
					<el-row :gutter="20" type="flex" class="row-bg">
						<el-col :span="24">
							<el-table :data="tableData4" border class="table" ref="multipleTable" v-loading="loading"
								max-height="600" header-cell-class-name="table-header"
								:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
								:header-cell-style="{ 'text-align': 'center' }" stripe
								@selection-change="handleSelectionChange">
								<!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
								<el-table-column prop="agent" label="代理商" align="center"
									min-width="180"></el-table-column>
								<el-table-column prop="company" label="企业" align="center"
									min-width="180"></el-table-column>
								<el-table-column prop="cardType" label="运营商" align="center"
									width="80"></el-table-column>
								<el-table-column prop="standard" label="制式" align="center" width="80"></el-table-column>
								<el-table-column prop="phone" label="号码" align="center" width="120"></el-table-column>
								<el-table-column prop="iccid" label="ICCID" align="center"
									width="180"></el-table-column>
								<el-table-column prop="phoneStatus" label="号码状态" align="center"
									width="110"></el-table-column>
								<el-table-column prop="uid" label="批次号" align="center" width="96"></el-table-column>
								<el-table-column prop="setMeal" label="套餐" align="center" width="150">
									<template #default="scope">
										<el-tooltip placement="top">
											<template #content>
												<div style="max-width: 300px; white-space: pre-wrap;"
													v-for='item in scope.row.setMealList' :key="item">
													{{item.min}}分钟{{item.price}}元
												</div>
											</template>
											<span>{{scope.row.setMeal}}</span>
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="type" label="类型" align="center" width="80"></el-table-column>
								<el-table-column prop="back" label="退卡" align="center" width="80">
									<template #default="scope">
										<el-tag v-if="scope.row.back==true" type="danger" size="small">是</el-tag>
										<el-tag v-if="scope.row.back==false" type="success" size="small">否</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" label="出库时间" align="center"
									show-overflow-tooltip></el-table-column>
								<el-table-column prop="operator" label="操作人" align="center"></el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="企业等级设置" name="agentGrade" v-if="isAdmin">
					<div class="handle-box">
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" class="fl_r m_b_20"
							@click="showAddEnterpriseLevelVisible">添加</el-button>
					</div>
					<el-table :data="tableData7" :border='true' class="table" ref="multipleTable" v-loading="loading"
						max-height="600" header-cell-class-name="table-header"
						:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
						:header-cell-style="{ 'text-align': 'center' }" stripe @selection-change="handleSelectionChange"
						style="width: 100%;">
						<el-table-column align="center" label="客户等级" prop="lv" width="80"></el-table-column>
						<el-table-column label="规则" align="center" min-width="680">
							<template #default="scope">
								<div v-for="item in scope.row.rules" :key="item"
									style="display: flex;flex-direction: row;margin-bottom: 6px;">
									<span style="margin:6px 10px 0 0;">在网</span>
									<el-input size="small" v-model="item.use1.type"
										style="width: 100px;margin: 0px 10px 0 0;" placeholder="运算符"
										disabled></el-input>
									<el-input size="small" v-model="item.use1.value"
										style="width: 100px;margin: 0px 10px 0 0;" placeholder="在网数量"
										disabled></el-input>
									<el-input size="small" v-model="item.use2.type"
										style="width: 100px;margin: 0px 10px 0 0;" placeholder="运算符"
										disabled></el-input>
									<el-input size="small" v-model="item.use2.value"
										style="width: 100px;margin: 0px 10px 0 0;" placeholder="在网数量"
										disabled></el-input>
									<span style="margin: 6px 10px 0 0;">投诉</span>
									<el-input size="small" v-model="item.complaint"
										style="width: 100px;margin: 0px 10px 0 0;" placeholder="投诉数量"
										disabled></el-input>
								</div>
							</template>
						</el-table-column>
						<el-table-column align="center" label="电话邦业务类型" prop="protectionLevel" width="180">
							<template #default="scope">
								<el-cascader v-model="scope.row.protectionLevel" :options="protectionLevel" size="small"
									disabled></el-cascader>
							</template>
						</el-table-column>
						<el-table-column align="center" label="御鑫业务类型" prop="yxLevel" width="120">
							<template #default="scope">
								<el-select size="small" v-model="scope.row.yxLevel" clearable placeholder="请选择御鑫等级"
									@change="yxLevelChang" disabled>
									<el-option label="禁用" :value="-1">禁用</el-option>
									<el-option label="一级" :value="1">一级</el-option>
									<el-option label="二级" :value="2">二级</el-option>
									<el-option label="三级" :value="3">三级</el-option>
									<el-option label="四级" :value="4">四级</el-option>
									<el-option label="五级" :value="5">五级</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column align="center" label="重复拨打" prop="repeatCall" width="80"></el-table-column>
						<el-table-column align="center" label="高频范围" prop="highFrequency" width="100">
							<template #default="scope">
								<el-switch v-model="scope.row.highFrequency" active-color="#13ce66"
									inactive-color="#ff4949" disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column align="center" label="共享风险号码" prop="riskNumber" width="100">
							<template #default="scope">
								<el-switch v-model="scope.row.riskNumber" active-color="#13ce66"
									inactive-color="#ff4949" disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column align="center" label="共享黑名单" prop="blacklist" width="85">
							<template #default="scope">
								<el-switch v-model="scope.row.blacklist" active-color="#13ce66" inactive-color="#ff4949"
									disabled></el-switch>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="180">
							<template #default="scope">
								<el-button size="small" type="text" icon="el-icon-edit" style="color: #409eff"
									@click="showEdit(scope.row)">编辑</el-button>
								<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
									@click="deleteEdit(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>

				<el-tab-pane label="企业黑名单" name="enterpriseBlacklist" v-if="isAdmin||isAgent">
					<div class="handle-box">
						<el-input size="small" v-model="query10.name" clearable placeholder="请输入名称" class="mr10"
							style="width: 180px;"></el-input>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getEnterpriseBlacklist">搜索</el-button>
						<el-button size="small" type="primary" :class="[theme]" @click="showAddBlackVisible"
							v-if="isAdmin">添加</el-button>
						<a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="企业黑名单模板.txt"
							:class="[theme]" v-if="isAdmin">
							<i class="el-icon-download"></i>
							下载模板
						</a>
					</div>
					<el-table :data="tableData10" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
						v-loading="loading">
						<el-table-column prop="name" label="企业名称" align="center"></el-table-column>
						<el-table-column prop="time" label="添加时间" align="center"></el-table-column>
						<el-table-column label="操作" width="280" align="center" v-if="isAdmin">
							<template #default="scope">
								<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
									@click="handleDeleteBlackList(scope.$index, scope.row.id)">
									删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query10.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query10.pageSize" :total="pageTotal10" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>

			</el-tabs>
		</div>
		<el-dialog title="添加" v-model="addEnterpriseLevelVisible" width="820px" @close="closeEnterpriseLevelDialog">
			<el-form label-width="120px" :model="addEnterpriseLevelForm" ref="addEnterpriseLevelForm">
				<el-form-item label="客户级别">
					<el-input size="small" placeholder="请输入企业等级" style="width: 220px;"
						v-model="addEnterpriseLevelForm.lv"></el-input>
				</el-form-item>
				<el-form-item label="御鑫等级" prop="yxLevel">
					<el-select size="small" v-model="addEnterpriseLevelForm.yxLevel" filterable clearable
						placeholder="请选择御鑫等级" style="width: 220px;" @change="yxLevelChang">
						<el-option label="禁用" :value="-1">禁用</el-option>
						<el-option label="一级" :value="1">一级</el-option>
						<el-option label="二级" :value="2">二级</el-option>
						<el-option label="三级" :value="3">三级</el-option>
						<el-option label="四级" :value="4">四级</el-option>
						<el-option label="五级" :value="5">五级</el-option>
					</el-select>
					<el-tooltip class="item" effect="dark" placement="top-start">
						<template #content>
							<div style="display: flex; flex-direction: column;">
								<div>1级(通知,语音验证码,回访)</div>
								<div>2级(催收,卫生保健,问卷调査,电器,装修,招商,会议,房产中介)</div>
								<div>3级(房产 游戏,保险,教育,挂靠,培训,汽车销售，养老)</div>
								<div>4级(招聘,旅游,网购，增值)</div>
								<div>5级(金融,证券,理财,贷款,股票,食药,POS)</div>
							</div>
						</template>
						<i class="el-icon-warning" style="margin-left: 10px;"></i>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="电话邦等级" prop="protectionLevel">
					<el-cascader v-model="addEnterpriseLevelForm.protectionLevel" :options="protectionLevel2"
						@change="handleChange" size="small" style="width: 220px;"></el-cascader>
					<a class="ywlx" href="https://images.10000.work/888.jpg" target="_blank"
						style="background-color: none;list-style: none;color: #000000;margin-left: 12px;">
						点击查看规则>>
					</a>
				</el-form-item>
				<el-form-item label="高频范围" prop="highFrequency">
					<el-switch v-model="addEnterpriseLevelForm.highFrequency" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 40px;">*</span>
					<span
						style="font-size: 12px;color: #878A93;">开启后该企业会共享{{ webInfo.webName }}所有黑名单号码，如果命中则拦截无法拨打。</span>
				</el-form-item>
				<el-form-item label="共享黑名单" prop="blacklist">
					<el-switch v-model="addEnterpriseLevelForm.blacklist" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 40px;">*</span>
					<span
						style="font-size: 12px;color: #878A93;">开启后该企业会共享{{ webInfo.webName }}所有黑名单号码，如果命中则拦截无法拨打。</span>
				</el-form-item>
				<el-form-item label="共享风险号码" prop="riskNumber">
					<el-switch v-model="addEnterpriseLevelForm.riskNumber" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 40px;">*</span>
					<span
						style="font-size: 12px;color: #878A93;">开启后该企业会共享{{ webInfo.webName }}当天所有风险号码，如果命中则拦截无法拨打。</span>
				</el-form-item>
				<el-form-item label="重复拨打" prop="repeatCall">
					<el-select size="small" v-model="addEnterpriseLevelForm.repeatCall"
						style="margin-right: 10px;margin-bottom: 10px;width: 100px;">
						<el-option :label="0" :value="0"></el-option>
						<el-option :label="1" :value="1"></el-option>
						<el-option :label="2" :value="2"></el-option>
						<el-option :label="3" :value="3"></el-option>
					</el-select>
					<span style="color: #ff0000;margin: 6px 6px 0 10px;">*</span>
					<span style="font-size: 12px;color: #878A93;">0为不限制企业同号码外呼次数。其他选项
						如1，则限制该企业同号码外呼次数为1次。</span>
				</el-form-item>
				<div v-for="(item,index) in addEnterpriseLevelForm.rules" :key="index">
					<el-form-item :label="'规则'+(index+1)" prop="number">
						<span style="margin: 0 10px 0 0;">在网</span>
						<el-select size="small" v-model="item.use1.type" placeholder="运算符"
							style="width: 90px;margin-right: 10px;" clearable>
							<el-option v-for="item in symbolList" :key="item" :label="item" :value="item"></el-option>
						</el-select>
						<el-input size="small" v-model="item.use1.value" style="width: 100px;margin: 4px 10px 0 0;"
							placeholder="在网数量" clearable></el-input>
						<el-select size="small" v-model="item.use2.type" placeholder="运算符"
							style="width: 90px;margin-right: 10px;" clearable>
							<el-option v-for="item in symbolList" :key="item" :label="item" :value="item"></el-option>
						</el-select>
						<el-input size="small" v-model="item.use2.value" style="width: 100px;margin: 4px 10px 0 0;"
							placeholder="在网数量" clearable></el-input>
						<span style="margin: 0 10px 0 0;">投诉</span>
						<el-input size="small" v-model="item.complaint" style="width: 100px;margin: 4px 10px 0 0;"
							placeholder="投诉数量" clearable></el-input>
						<i v-if="index === addEnterpriseLevelForm.rules.length - 1" class="el-icon-circle-plus"
							style="color: #4f7afd;font-size: 26px;position: relative;top:6px;cursor: pointer;"
							@click.prevent="addDomain"></i>
						<i v-if="index === addEnterpriseLevelForm.rules.length - 1" class="el-icon-remove"
							style="color: #4f7afd;font-size: 26px;position: relative;top:6px;cursor: pointer;"
							@click.prevent="removeDomain(item)"></i>
					</el-form-item>
				</div>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeEnterpriseLevelDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="addEnterpriseLevelFormUpdate"
						@click="getUpdateEnterpriseLevel">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="getAddEnterpriseLevel">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="添加企业" v-model="addVisible" width="1000px" @close="closeDialog('form')"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px">
				<el-form-item label="企业名称" prop="name">
					<el-input size="small" v-model="form.name" :disabled="canRemoveCompany"></el-input>
				</el-form-item>
				<el-form-item label="企业代码" prop="code">
					<el-input size="small" v-model="form.code" :disabled="canRemoveCompany"></el-input>
				</el-form-item>
				<div class="content_box">
					<div class="content_top">
						<!-- 传入营业执照 -->
						<el-form-item label="营业执照" prop="businessLicense">
							<el-upload :disabled="canRemoveCompany" :action="domain" :limit="1" list-type="picture-card"
								:file-list="fileList1" :auto-upload="false" ref="upload1"
								accept="image/png,image/jpg,image/jpeg" :on-change="getbusinessLicense" :data="token1"
								:http-request="httprequest" :class="{ hide: hideUpload1 }"
								:on-preview="handlePictureCardPreview1" :on-remove="handleRemove1"
								:before-remove="beformRemove1">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible1"><img :src="dialogImageUrl1"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
						<!-- 传入身份证正面 -->
						<el-form-item label="身份证正面" prop="idcardFront">
							<el-upload :disabled="canRemoveCompany" :action="idcardFront" :limit="1"
								list-type="picture-card" :file-list="fileList2" :auto-upload="false" ref="upload2"
								accept="image/png,image/jpg,image/jpeg" :on-change="getIDCardFront" :data="idcardFront"
								:http-request="httprequest" :class="{ hide: hideUpload2 }"
								:before-remove="beformRemove1" :on-preview="handlePictureCardPreview2"
								:on-remove="handleRemove2">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible2"><img :src="dialogImageUrl2"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
						<!-- 传入身份证反面 -->
						<el-form-item label="身份证反面" prop="idcardReverse">
							<el-input size="small" v-model="form.idcardReverse" v-if="false"></el-input>
							<el-upload :disabled="canRemoveCompany" :action="idcardReverse" :limit="1"
								list-type="picture-card" :file-list="fileList3" :auto-upload="false" ref="upload3"
								accept="image/png,image/jpg,image/jpeg" :on-change="getIDCardReverse"
								:data="idcardReverse" :http-request="httprequest" :class="{ hide: hideUpload3 }"
								:before-remove="beformRemove1" :on-preview="handlePictureCardPreview3"
								:on-remove="handleRemove3">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible3"><img :src="dialogImageUrl3"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
					</div>
					<div class="content_middle">
						<!-- 法人免冠照一张 -->
						<el-form-item label="法人免冠照" prop="legalPersonPhotos">
							<el-input size="small" v-model="form.legalPersonPhotos" v-if="false"></el-input>
							<el-upload :disabled="canRemoveCompany" :action="legalPersonPhotos" :limit="1"
								list-type="picture-card" :file-list="fileList4" :auto-upload="false" ref="upload4"
								accept="image/png,image/jpg,image/jpeg" :on-change="getlegalPersonPhotos"
								:data="legalPersonPhotos" :http-request="httprequest" :class="{ hide: hideUpload4 }"
								:before-remove="beformRemove1" :on-preview="handlePictureCardPreview4"
								:on-remove="handleRemove4">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible4"><img :src="dialogImageUrl4"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
						<div>
							<!-- 话术模板 -->
							<el-form-item label="话术模板(1)" prop="template1">
								<el-upload :disabled="canRemoveCompany" :action="template1" list-type="picture-card"
									:file-list="fileList5" :auto-upload="false" ref="upload5"
									accept="image/png,image/jpg,image/jpeg" :on-change="gettemplate1" :data="template1"
									:http-request="httprequest" :limit="1" :class="{ hide: hideUpload5 }"
									:before-remove="beformRemove1" :on-preview="handlePictureCardPreview5"
									:on-remove="handleRemove5">
									<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
								</el-upload>
								<el-dialog v-model="addVisible5"><img :src="dialogImageUrl5"
										style="width: 100%;" /></el-dialog>
							</el-form-item>
						</div>
						<!-- 话术模板 -->
						<el-form-item label="话术模板(2)" prop="template2">
							<el-upload :disabled="canRemoveCompany" :action="template2" list-type="picture-card"
								:file-list="fileList6" :auto-upload="false" ref="upload6"
								accept="image/png,image/jpg,image/jpeg" :on-change="gettemplate2" :data="templat2"
								:http-request="httprequest" :limit="1" :class="{ hide: hideUpload6 }"
								:before-remove="beformRemove1" :on-preview="handlePictureCardPreview6"
								:on-remove="handleRemove6">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible6"><img :src="dialogImageUrl6"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
					</div>
					<div class="content_bottom">
						<!-- 话术模板 -->
						<el-form-item label="话术模板(3)" prop="template3">
							<el-upload :disabled="canRemoveCompany" :action="template3" list-type="picture-card"
								:file-list="fileList7" :auto-upload="false" ref="upload7"
								accept="image/png,image/jpg,image/jpeg" :on-change="gettemplate3" :data="template3"
								:http-request="httprequest" :limit="1" :class="{ hide: hideUpload7 }"
								:before-remove="beformRemove1" :on-preview="handlePictureCardPreview7"
								:on-remove="handleRemove7">
								<el-button size="small" type="primary" :class="[theme]">点击上传</el-button>
							</el-upload>
							<el-dialog v-model="addVisible7"><img :src="dialogImageUrl7"
									style="width: 100%;" /></el-dialog>
						</el-form-item>
						<div>
							<!-- 话术模板 -->
							<el-form-item label="办公场景视频" prop="template4">
								<el-upload :disabled="canRemoveCompany" :action="template4" list-type="picture-card"
									:file-list="fileList8" :auto-upload="false" ref="upload8" accept="video/*"
									:on-change="gettemplate4" :data="template4" :http-request="httprequest" :limit="1"
									:class="{ hide: hideUpload8 }" :before-remove="beformRemove2"
									:on-preview="handlePictureCardPreview8" :on-remove="handleRemove8">
									<el-button size="small" type="primary" :class="[theme]">上传视频</el-button>
								</el-upload>
								<el-dialog v-model="addVisible8" @close="closeDialogdialogImageUrl8">
									<div style="display: flex;flex-direction: row;justify-content: center;">
										<video v-if="dialogImageUrl8" controls style="max-height: 500px;">
											<source :src="dialogImageUrl8" type="video/mp4">
											<source :src="dialogImageUrl8" type="video/webm">
										</video>
									</div>
								</el-dialog>
							</el-form-item>
						</div>
						<!-- 话术模板 -->
						<el-form-item label="告知书" prop="template5">
							<el-upload :disabled="canRemoveCompany" :action="template5" list-type="picture-card"
								:file-list="fileList9" :auto-upload="false" ref="upload9" accept="video/*"
								:on-change="gettemplate5" :data="template5" :http-request="httprequest" :limit="1"
								:class="{ hide: hideUpload9 }" :before-remove="beformRemove2"
								:on-preview="handlePictureCardPreview9" :on-remove="handleRemove9">
								<el-button size="small" type="primary" :class="[theme]">上传视频</el-button>
							</el-upload>
							<el-dialog v-model="addVisible9" @close="closeDialogdialogImageUrl9">
								<div style="display: flex;flex-direction: row;justify-content: center;">
									<video v-if="dialogImageUrl9" controls style="max-height: 500px;">
										<source :src="dialogImageUrl9" type="video/mp4">
										<source :src="dialogImageUrl9" type="video/webm">
									</video>
								</div>
							</el-dialog>
						</el-form-item>
					</div>
				</div>
				<el-form-item label="代理商" v-if="isAdmin" prop="agentId">
					<el-select size="small" v-model="form.agentId" filterable clearable placeholder="代理商"
						class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in agents" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="子代理" prop="subAgentId" v-if="isSubAgent">
					<el-select size="small" v-model="form.subAgentId" @change="getfetchDefaultCompanies" filterable
						clearable placeholder="子代理" class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in subAgentList" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业联系人" prop="ownerName">
					<el-input size="small" v-model="form.ownerName"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="ownerPhone">
					<el-input size="small" v-model="form.ownerPhone"></el-input>
				</el-form-item>
				<el-form-item label="企业类型" prop="businessType">
					<el-select size="small" style="width: 100%;" v-model="form.businessType" filterable clearable
						placeholder="企业类型" class="handle-select mr10" :disabled="protectionLevelTrue">
						<el-option v-for="item in businessTypeList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业等级" prop="classification">
					<el-input size="small" v-model="form.classification"></el-input>
				</el-form-item>
				<div><!-- v-if="isAdmin" -->
					<el-form-item label="过滤方式" v-if="iscompany"
						style="background: #E9EAEF;margin-bottom: 0;padding-top: 11px;">
						<el-checkbox-group v-model="form.filtration" :disabled="form.locked" @change="getfiltration">
							<el-checkbox label="non" value="non">不过滤</el-checkbox>
							<el-checkbox label="dhb" value="dhb" v-if="form.filtration=='non'"
								disabled>电话邦</el-checkbox>
							<el-checkbox label="dhb" value="dhb" v-else>电话邦</el-checkbox>
							<el-checkbox label="yx" value="yx" v-if="form.filtration=='non'" disabled>御鑫</el-checkbox>
							<el-checkbox label="yx" value="yx" v-else>御鑫</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="电话邦等级" prop="protectionLevel"
						style="background: #E9EAEF;margin-bottom: 0;padding-top: 11px;">
						<el-cascader v-model="form.protectionLevel" :options="protectionLevel" @change="handleChange"
							size="small" :disabled="protectionLevelTrue||form.locked||dhbdis"
							class="handle-select mr10"></el-cascader>
						<a class="ywlx" href="https://images.10000.work/888.jpg" target="_blank"
							style="background-color: none;list-style: none;color: #000000;margin-left: 12px;">
							点击查看规则>>
						</a>
					</el-form-item>
					<el-form-item label="御鑫等级" style="background: #E9EAEF;margin-bottom: 0;padding-top: 11px;"
						prop="yxLevel">
						<el-select size="small" v-model="form.yxLevel" filterable clearable placeholder="请选择御鑫等级"
							class="handle-select mr10" :disabled="protectionLevelTrue||form.locked||yxdis"
							@change="yxLevelChang">
							<el-option :label="1" :value="1">一级</el-option>
							<el-option :label="2" :value="2">二级</el-option>
							<el-option :label="3" :value="3">三级</el-option>
							<el-option :label="4" :value="4">四级</el-option>
							<el-option :label="5" :value="5">五级</el-option>
						</el-select>
						<el-tooltip class="item" effect="dark" placement="top-start">
							<template #content>
								<div style="display: flex; flex-direction: column;">
									<div>1级(通知,语音验证码,回访)</div>
									<div>2级(催收,卫生保健,问卷调査,电器,装修,招商,会议,房产中介)</div>
									<div>3级(房产 游戏,保险,教育,挂靠,培训,汽车销售，养老)</div>
									<div>4级(招聘,旅游,网购，增值)</div>
									<div>5级(金融,证券,理财,贷款,股票,食药,POS)</div>
								</div>
							</template>
							<i class="el-icon-warning"></i>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="重复拨打" prop="repeatCall"
						style="background: #E9EAEF;margin-bottom: 0;padding-top: 11px;">
						<el-select size="small" v-model="form.repeatCall" :disabled="form.locked"
							style="margin-right: 10px;margin-bottom: 10px;" class="handle-select mr10">
							<el-option :label="0" :value="0"></el-option>
							<el-option :label="1" :value="1"></el-option>
							<el-option :label="2" :value="2"></el-option>
							<el-option :label="3" :value="3"></el-option>
						</el-select>
						<span style="color: #ff0000;margin: 6px 6px 0 10px;">*</span>
						<span style="font-size: 12px;color: #878A93;">0为不限制企业同号码外呼次数。其他选项
							如1，则限制该企业同号码外呼次数为1次。</span>
					</el-form-item>
					<el-form-item label="高频范围" prop="highFrequency"
						style="background: #E9EAEF;margin-bottom: 0;padding-top: 11px;" v-if="repeatCallgew">
						<el-switch v-model="form.highFrequency" :disabled="form.locked" active-color="#13ce66"
							inactive-color="#ff4949"></el-switch>
						<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
						<span style="font-size: 12px;color: #878A93;"
							v-if="form.highFrequency">{{ webInfo.webName }}所有外呼生效</span>
						<span style="font-size: 12px;color: #878A93;" v-else>企业内所有外呼生效</span>
					</el-form-item>
					<el-form-item label="共享黑名单" prop="blacklist" v-if="repeatCallgew"
						style="background: #E9EAEF;padding-top: 0;margin:0">
						<el-switch v-model="form.blacklist" active-color="#13ce66" inactive-color="#ff4949"
							:disabled="form.locked"></el-switch>
						<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
						<span
							style="font-size: 12px;color: #878A93;">开启后该企业会共享{{ webInfo.webName }}所有黑名单号码，如果命中则拦截无法拨打。</span>
					</el-form-item>
					<el-form-item label="共享风险号码" prop="riskNumber" v-if="repeatCallgew"
						style="background: #E9EAEF;padding-top: 0px;margin-bottom: 0;">
						<el-switch v-model="form.riskNumber" active-color="#13ce66" inactive-color="#ff4949"
							:disabled="form.locked"></el-switch>
						<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
						<span
							style="font-size: 12px;color: #878A93;">开启后该企业会共享{{ webInfo.webName }}当天所有风险号码，如果命中则拦截无法拨打。</span>
					</el-form-item>
					<el-form-item label="锁定" prop="locked" v-if="isAdmin && updateButton"
						style="background: #E9EAEF;padding-bottom: 11px;">
						<el-switch v-model="form.locked" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
						<span style="color: #ff0000;margin-left: 20px;font-size: 12px;">*
							锁定后该企业的企业类型，高频范围，重复拨打次数非管理员权限不可编辑。</span>
					</el-form-item>
				</div>
				<el-form-item label="外呼时段" prop="callTime" style="margin-top: 30px;">
					<drag-weektime v-model:value="multTimeRange" :data="weektimeData" @on-clear="clearWeektime"
						@on-all="allWeektime" v-if="addButton"></drag-weektime>
					<drag-weektime v-model:value="multTimeRange2" :data="weektimeData2" @on-clear="clearWeektime2"
						@on-all="allWeektime2" v-if="updateButton"></drag-weektime>
				</el-form-item>
				<el-form-item label="禁呼地区" prop="callRestrictions">
					<div class="city-selector">
						<el-input placeholder="搜索城市" v-model="searchQuery" clearable @input="handleSearch2"
							style="width: 140px; margin-right: 10px" size="small" />
						<el-select v-model="callRestrictions" multiple clearable placeholder="请选择城市" style="width: 60%"
							size="small">
							<el-option-group v-for="group in filteredGroups" :key="group.label" :label="group.label">
								<el-option v-for="city in group.children" :key="city.value" :label="city.label"
									:value="city.value" />
							</el-option-group>
						</el-select>
					</div>
				</el-form-item>
				<el-form-item label="使用地址" prop="city">
					<el-tag class="m_r_10" v-for="tag in form.city" :key="tag" closable
						@close="handleClose(tag)">{{ tag }}</el-tag>
					<el-input v-if="inputVisible" ref="saveTagInput" v-model="inputValue" size="small"
						class="input-new-tag" style="width: 180px;" @keyup.enter="handleInputConfirm"
						@blur="handleInputConfirm"></el-input>
					<el-button v-else size="small" class="button-new-tag" @click="showInput">添加城市</el-button>
				</el-form-item>
				<el-form-item label="部门开启" prop="department" v-if="isAdmin||isagent">
					<el-switch v-model="form.department" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="color: #ff0000;font-size: 12px;">
						开启后给该企业下添加部门，部门名称为销售一部（后期可编辑修改）。</span>
				</el-form-item>
				<el-form-item label="号码保护" prop="desensitization">
					<el-switch v-model="form.desensitization" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="font-size: 12px;color: #878A93;">开启号码保护功能，被叫号码中间四位数加密，所有通话记录和通话详情位置生效。</span>
				</el-form-item>
				<el-form-item :label="repeatText" prop="repeat" v-if="isAdmin||isagent">
					<el-switch v-model="form.repeat" active-color="#13ce66" inactive-color="#ff4949"
						@change="getswitch"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="color: #ff0000;font-size: 12px;">
						开启去重功能，同一企业下重复号码自动过滤，对系统所有导入号码的位置生效，包括PC端导入、APP端导入、文字识别导入。
					</span>
				</el-form-item>
				<el-form-item label="使用小程序" prop="applet" v-if="isAdmin || isagent">
					<el-switch v-model="form.applet" active-color="#13ce66" inactive-color="#ff4949"
						@change="getappletswitch"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="color: #ff0000;font-size: 12px;"> 默认是开启状态，可使用小程序，关闭就无法使用小程序 。</span>
				</el-form-item>
				<el-form-item label="号码导出" prop="export">
					<el-switch v-model="form.export" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="font-size: 12px;color: #878A93;">开启或关闭APP端和PC端话单导出功能。</span>
				</el-form-item>
				<el-form-item label="SKR录音" prop="zxRecordIng" v-if="isAdmin||isagent">
					<el-switch v-model="form.zxRecordIng" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="font-size: 12px;color: #878A93;">开启后将开启SKR录音。</span>
				</el-form-item>
				<el-form-item label="自动拨号" prop="automaticCall" v-if="isAdmin||isagent">
					<el-switch v-model="form.automaticCall" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="font-size: 12px;color: #878A93;">开启或者关闭自动拨号。</span>
				</el-form-item>
				<el-form-item label="每日语音质检" prop="repeatCall" v-if="isAgent || isAdmin">
					<el-select size="small" :disabled="canRemoveCompany" v-model="form.aiQuality" placeholder="请选择"
						style="width: 220px;">
						<el-option label="不质检" value="0"></el-option>
						<el-option label="全检" value="5"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="在线客服" prop="onlineServer" v-if="isAdmin||isagent">
					<el-switch v-model="form.onlineServer" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin: 6px 6px 0 20px;">*</span>
					<span style="font-size: 12px;color: #878A93;">开启或者关闭在线客服。</span>
				</el-form-item>
			</el-form>
			<span class="dialog-footer dis-end">
				<el-button size="small" @click="closeDialog('form')">取消</el-button>
				<el-button size="small" v-if="addButton" :loading="loading1" type="primary" :class="[theme]"
					@click="addCompany('form')">确定</el-button>
				<el-button size="small" v-if="updateButton" :loading="loading2" type="primary" :class="[theme]"
					@click="updateCompany('form')">确定</el-button>
			</span>
		</el-dialog>
		<el-dialog v-model="isrepeatBox" width="450px" :show-close="false" :close-on-click-modal="false">
			<div>
				<div style="text-align: center;">
					<i class="el-icon-warning-outline" style="color: #F56C6C;font-size: 76px;margin-bottom: 35px;"></i>
					<div style="margin-left: 20px;text-align: left;font-size: 16px;">
						关闭去重功能，会出现同一个号码重复分配给不同员工，极有可能出现撞单和频繁骚扰情况，请谨慎使用！
					</div>
				</div>
				<div style="display: flex;flex-direction: row;justify-content: end;margin-top: 50px;">
					<el-button size="small" @click="setRepeatMode(true)">去重</el-button>
					<el-button size="small" type="danger" @click="setRepeatMode(false)">不去重</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title="添加销户" v-model="lockVisible" width="650px" @close="closeDialog2">
			<el-form label-width="120px" :model="lockForm" ref="lockForm">
				<el-form-item label="锁定" prop="locked">
					<el-switch v-model="lockForm.locked" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
					<span style="color: #ff0000;margin-left: 20px;font-size: 12px;">*
						锁定后该企业的企业类型，高频范围，重复拨打次数非管理员权限不可编辑。</span>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: end">
					<el-button size="small" @click="closeDialog2">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getLocks">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="批量设置" v-model="companyBatchSystemInterceptionVisible" width="650px"
			@close="closecompanyBatchSystemInterceptionDialog">
			<el-form label-width="120px" :model="companyBatchSystemInterceptionForm"
				ref="companyBatchSystemInterceptionForm">
				<el-form-item label="高频范围" prop="highFrequency">
					<el-switch v-model="companyBatchSystemInterceptionForm.highFrequency" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
				</el-form-item>
				<el-form-item label="共享黑名单" prop="blacklist">
					<el-switch v-model="companyBatchSystemInterceptionForm.blacklist" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
				</el-form-item>
				<el-form-item label="共享风险号码" prop="riskNumber">
					<el-switch v-model="companyBatchSystemInterceptionForm.riskNumber" active-color="#13ce66"
						inactive-color="#ff4949"></el-switch>
				</el-form-item>
				<el-form-item style="display: flex;flex-direction: row;justify-content: end">
					<el-button size="small" @click="closecompanyBatchSystemInterceptionDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="getCompanyBatchSystemInterception">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="修改记录" v-model="contentVisible" width="850px" @close="closeDialog3">
			<el-table :data="tableData3" :border='true' class="table" ref="multipleTable" v-loading="loading"
				max-height="600" header-cell-class-name="table-header"
				:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe style="width: 100%;">
				<el-table-column prop="userPhone" label="操作者" align="center" width="120"></el-table-column>
				<el-table-column prop="type" label="操作类型" align="center" width="120"></el-table-column>
				<el-table-column prop="role" label="权限" align="center" width="120"></el-table-column>
				<el-table-column prop="companyName" label="企业名称" align="center"></el-table-column>
				<el-table-column prop="content" label="内容" align="center"></el-table-column>
				<el-table-column prop="time" label="时间" align="center" width="180"></el-table-column>
			</el-table>
		</el-dialog>
		<el-dialog title="手动添加" v-model="addOutboundVisible" width="650px" :close-on-click-modal="false">
			<el-form :model="addOutboundForm" ref="addOutboundForm" label-width="120px">
				<el-form-item label="代理" prop="agent">
					<el-select v-model="addOutboundForm.agent" @change="companyChange" clearable filterable
						placeholder="请选择代理商" size="small" style="width: 100%;">
						<el-option v-for="item in agentsList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业" prop="companyId">
					<el-select v-model="addOutboundForm.companyId" clearable filterable placeholder="请选择企业" size="small"
						style="width: 100%;">
						<el-option v-for="item in companysList" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="添加号码">
					<el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码,一次最多添加100个号码"
						v-model="addOutboundForm.phones"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="addOutboundVisibleClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getAddOutbound">确定上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<express-detail-dialog v-if="dialogOutboundVisible" v-model="dialogOutboundVisible" :express-info="expressData"
			@close="handleClose2" />
		<el-dialog title="上传添加" v-model="uploadOutboundVisible" width="650px" @close="uploadformClose">
			<el-form :model="uploadOutboundform" ref="addForm" label-width="120px">
				<el-form-item label="上传文件">
					<el-upload ref="uploadOutbound" action="/api/SjtxCard/temporaryDelivery" :headers="token" :limit="1"
						:on-preview="handlePreview" :on-remove="handleRemove" :on-success="uploadSuccess"
						:auto-upload="false" :data="uploadOutboundform" :before-upload="beforeUpload">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="uploadformClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]"
						@click="submitOutboundUpload">确定上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="出库限频" v-model="frequencyLimitingVisible" width="450px" @close="frequencyLimitingClose">
			<el-form :model="frequencyLimitingForm" ref="frequencyLimitingForm" label-width="120px">
				<el-form-item label="制式">
					<el-select size="small" v-model="frequencyLimitingForm.standard" clearable filterable multiple
						placeholder="请选择制式" style="width: 260px;">
						<el-option v-for="item in standardList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="接通频次">
					<el-input size="small" v-model="frequencyLimitingForm.num" clearable placeholder="请输入限频次数"
						style="width: 260px;"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="frequencyLimitingClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="frequencyLimitingSet">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="审核" v-model="auditVisible" width="450px" @close="auditClose">
			<el-form :model="auditForm" ref="auditForm" label-width="80px">
				<el-form-item label="状态">
					<el-select size="small" v-model="auditForm.enable" clearable filterable placeholder="请选择状态"
						style="width: 100%;">
						<el-option v-for="item in enableList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="审核原因">
					<el-input size="small" v-model="auditForm.remark" type="textarea" :rows="5" clearable
						placeholder="请输入审核原因" style="width: 100%;"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="auditClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getCompanyAudit">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="审核" v-model="auditRecordVisible" width="700px" @close="auditRecordClose">
			<el-table :data="tableData9" :border='true' class="table" ref="multipleTable" v-loading="loading"
				max-height="600" header-cell-class-name="table-header"
				:cell-style="{ cursor: 'pointer', padding: '6px' }" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe style="width: 100%;">
				<el-table-column prop="account" label="操作者" align="center" width="120"></el-table-column>
				<el-table-column prop="status" label="审核状态" align="center">
					<template #default="scope">
						<el-tag type="warning" v-if="scope.row.status=='待审核'" size="small">{{scope.row.status}}</el-tag>
						<el-tag type="danger" v-if="scope.row.status=='审核失败'" size="small">{{scope.row.status}}</el-tag>
						<el-tag type="primary" v-if="scope.row.status=='审核通过'"
							size="small">{{scope.row.status}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="内容" align="center"></el-table-column>
				<el-table-column prop="time" label="时间" align="center" width="180"></el-table-column>
			</el-table>
		</el-dialog>

		<el-dialog title="批量添加" v-model="addBlackVisible" width="520px" @close="closeAddBlackDialog">
			<el-form label-width="120px" :model="addBlackForm" ref="addBlackForm">
				<el-form-item label="上传类型" prop="type">
					<el-radio-group v-model="addBlackForm.type">
						<el-radio label="1">手动输入</el-radio>
						<el-radio label="2">批量添加模板</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="上传文件" v-if="addBlackForm.type=='2'">
					<el-upload ref="uploadaddCompanyBlack" action="/api/company/addCompanyBlacklist" :headers="token"
						:limit="1" :on-success="uploadaddBlackSuccess" :auto-upload="false" :data="addBlackForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入txt文件</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="企业名称" v-if="addBlackForm.type=='1'">
					<el-input size="small" :rows="5" type="textarea" v-model="addBlackForm.companyNames"
						auto-complete="off" placeholder="一行一个企业,一次最多添加500个企业"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeAddBlackDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-if="addBlackForm.type == '1'"
						@click="getAddCompanyBlacklist">确定</el-button>
					<el-button size="small" type="primary" :class="[theme]" v-else
						@click="submitUploadAddCompanyBlacklist">文件上传</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="重复黑名单企业" v-model="duplicateBlacklistVisible" width="420px"
			@close="closeDuplicateBlacklistDialog">
			<p v-for="item in duplicateBlacklist" :key="item">{{item}}</p>
		</el-dialog>
		<el-dialog title="在网数据" v-model="showChildrenVisible" width="920px">
			<el-table :data="childrenTableData" :border='true' class="table" ref="multipleTable" v-loading="loading"
				max-height="650" header-cell-class-name="table-header" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe style="width: 100%;">
				<el-table-column prop="company" label="企业" align="center"></el-table-column>
				<el-table-column prop="cardType" label="运营商" align="center" width="120"></el-table-column>
				<el-table-column prop="standard" label="制式" align="center" width="120"></el-table-column>
				<el-table-column prop="phone" label="号码" align="center" width="140"></el-table-column>
			</el-table>
			<div class="pagination" style="display: flex;flex-direction: row;justify-content:end;">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query20.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query20.pageSize" :total="childrenPageTotal" @size-change="handleSizeChange2"
					@current-change="handlePageChange2"></el-pagination>
				<el-button size="small" type="text" icon="el-icon-download" @click="getCompanyUseInfoDownload"
					:class="[theme3]">导出</el-button>
			</div>
		</el-dialog>


	</div>
</template>
<script>
	import {
		list,
		delCompany,
		addCompany,
		updateCompany,
		fetchCompanyById,
		fetchCompanyByAgentId,
		fetchDefaultCompanies,
		updateEnable,
		fetchCompanyType,
		downloadCompany,
		batchLocked,
		companyLvLog,
		companyUseData,
		companyUseInfo,
		companyUseInfoDownload,
		addRules,
		updateRules,
		deleteRules,
		companyRulesSettingList,
		companyBatchSystemInterception,
		enterpriseManualRating,
		companyAuditList,
		companyAudit,
		companyBlacklist,
		addCompanyBlacklist,
		deleteBlackList,
		activateRecord,
		activateInfo,
		activateExport
	} from '../api/companyIndex.js';
	import {
		deliveryList,
		logisticsInquiry,
		setMealList,
		deliveryOperator,
		deliveryCity,
		downloadOutboundTemplate,
		temporaryDelivery,
		InventoryInfo,
		dxtLimitCall,
		deliveryDownload,
		queryProvinceCity,
		exportWarehouse
	} from '../api/SjtxCard.js';
	import {
		fetchAgent,
		getCity
	} from '../api/agentIndex';
	import {
		getOemInfo
	} from '../api/index.js';
	import {
		querySubAgent
	} from '../api/serialIndex.js';
	import {
		getCardType
	} from '../api/cardType.js';
	import ExpressDetailDialog from '../components/ExpressDetailDialog.vue'
	import DragWeektime from "../components/dragWeekTime.vue";
	import handleData, {
		splicing
	} from "../components/handleData";
	import {
		debounce
	} from 'lodash';
	const video = document.createElement('video');
	export default {
		name: 'company',
		components: {
			ExpressDetailDialog,
			DragWeektime
		},
		data() {
			return {

				weektimeData: handleData([{
						id: 0,
						week: "星期一",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 1,
						week: "星期二",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 2,
						week: "星期三",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 3,
						week: "星期四",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 4,
						week: "星期五",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 5,
						week: "星期六",
						value: "08:00~12:00、13:30~18:30",
					},
					{
						id: 6,
						week: "星期日",
						value: "08:00~12:00、13:30~18:30",
					}
				]),
				weektimeData2: handleData([]),
				path: process.env.BASE_URL,
				addBlackVisible: false,
				addBlackForm: {
					type: '1',
					companyNames: '',
					file: '',
				},
				loading: false,
				theme: localStorage.getItem('theme'),
				theme2: localStorage.getItem('theme2'),
				theme3: localStorage.getItem('theme3'),
				theme7: localStorage.getItem('theme7'),
				theme8: localStorage.getItem('theme8'),
				uploadDisabled: false,
				repeatText: '号码去重',
				dialogVisible: false,
				ruleForm: {
					dialogImageUrl: '1', //专区logo 上传到后台之后，后台会返回一个id,只需要给后台传id,但是点击编辑的时候后台返回的是http地址
				},
				lockForm: {
					locked: true,
				},
				query: {
					companyId: '',
					agentId: null,
					businessType: '',
					enable: '',
					locked: '',
					companyName: '',
					status: '',
					subAgentId: '',
					filtration: '',
					yxLevel: '', //御鑫等级
					pageIndex: 1,
					pageSize: 10,
				},

				tableKey: 0,
				filtrationList: [{
					value: 'non',
					label: '不过滤',
				}, {
					value: 'dhb',
					label: '电话邦',
				}, {
					value: 'yx',
					label: '御鑫',
				}],

				ids: '',
				idcardFront: '',
				idcardReverse: '',
				legalPersonPhotos: '',
				template1: '',
				template2: '',
				template3: '',
				template4: '',
				template5: '',
				businessTypeList: [],
				domain: 'https://upload-z2.qiniup.com',
				qiniuaddr: ' r8s8zg6k5.hn-bkt.clouddn.com',
				token1: {},
				config: null,
				keyname: '',
				formdata: '',
				imageUrl: '',
				detailsVisible: false,
				tableData2: [],
				tableData3: [],
				isSubAgent: false,
				dialogImageUrl1: null,
				dialogImageUrl2: null,
				dialogImageUrl3: null,
				dialogImageUrl4: null,
				dialogImageUrl5: null,
				dialogImageUrl6: null,
				dialogImageUrl7: null,
				dialogImageUrl8: null,
				dialogImageUrl9: null,
				addVisible1: false,
				addVisible2: false,
				addVisible3: false,
				addVisible4: false,
				addVisible5: false,
				addVisible6: false,
				addVisible7: false,
				addVisible8: false,
				addVisible9: false,
				hideUpload1: false,
				hideUpload2: false,
				hideUpload3: false,
				hideUpload4: false,
				hideUpload5: false,
				hideUpload6: false,
				hideUpload7: false,
				hideUpload8: false,
				hideUpload9: false,
				webInfo: '',
				limitCount: 1,
				fileList1: [],
				fileList2: [],
				fileList3: [],
				fileList4: [],
				fileList5: [],
				fileList6: [],
				fileList7: [],
				fileList8: [],
				fileList9: [],
				coverUrl: '',
				tableData: [],
				companys: [],
				multipleSelection: [],
				delList: [],
				agents: [],
				editVisible: false,
				addVisible: false,
				addButton: false,
				updateButton: false,
				canAddCompany: true,
				canEditCompany: false,
				protectionLevelTrue: true,
				canRemoveCompany: true,
				isAdmin: false,
				isagent: false,
				iscompany: true,
				pageTotal: 0,
				form: {
					name: '',
					code: '',
					businessType: '',
					businessLicense: null,
					idcardFront: null,
					idcardReverse: null,
					legalPersonPhotos: null,
					template1: null,
					template2: null,
					template3: null,
					template4: null,
					template5: null,
					ownerName: '',
					ownerPhone: '',
					classification: '',
					protectionLevel: '0',
					desensitization: false,
					repeat: true, //是否去重
					export: false, //是否导出
					repeatCall: 1, //是否重复拨打
					blacklist: true, //共享黑名单
					riskNumber: true, // 共享风险号码
					frequency: '',
					highFrequency: true, //高频开启
					applet: true,
					department: true,
					locked: false,
					zxRecordIng: false,
					automaticCall: true,
					aiQuality: '全检',
					currentUserId: "",
					filtration: [], //过滤方式
					yxLevel: '三级', //御鑫等级
					city: [],
					onlineServer: false, //在线客服开启
				},
				callRestrictions: [], // 初始值（多个城市）
				searchQuery: '',
				allGroups: [],
				filteredGroups: [],
				visibleCityCount: 0,
				pinyinMap: {},
				inputValue: '',
				inputVisible: false,
				repeatCall: 1, //是否重复拨打
				repeatCallgew: false, //是否显示重复拨打
				idx: -1,
				id: -1,
				loading1: false,
				loading2: false,
				isrepeatBox: false,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2',
				},
				rules: {
					name: [{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur',
					}],
					code: [{
						required: true,
						message: '请输入企业代码',
						trigger: 'blur',
					}],
					ownerName: [{
						required: true,
						message: '请输入负责人',
						trigger: 'blur',
					}],
					ownerPhone: [{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur',
					}],
					protectionLevel: [{
						required: true,
						message: '请选择电话邦等级',
						trigger: 'blur',
					}],
					yxLevel: [{
						required: true,
						message: '请选择御鑫等级',
						trigger: 'blur',
					}],
					agentId: [{
						required: true,
						message: '请输入代理商',
						trigger: 'blur',
					}]
				},
				protectionLevel: [{
						value: '',
						label: 'A+模型',
						children: [{
							value: '24',
							label: 'A+模型',
						}]
					},
					{
						value: '',
						label: '催收',
						children: [{
								value: '2',
								label: '催本人'
							},
							{
								value: '32',
								label: '催紧急联系人'
							},
							{
								value: '33',
								label: '催三方'
							}
						]
					},
					{
						value: '',
						label: '金融',
						children: [{
								value: '4',
								label: '贷款（个人）'
							},
							{
								value: '11',
								label: 'hy2'
							},
							{
								value: '7',
								label: 'hy1'
							},
							{
								value: '23',
								label: '信用卡'
							},
							{
								value: '16',
								label: 'POS 机 '
							},
							{
								value: '9',
								label: '理财产品'
							},
							{
								value: '6',
								label: '保险'
							}
						]
					},
					{
						value: '',
						label: '企业服务',
						children: [{
								value: '31',
								label: '贷款'
							},
							{
								value: '30',
								label: '财税、印花税 '
							},
							{
								value: '29',
								label: '法律咨询 '
							}
						]
					},
					{
						value: '',
						label: '游戏',
						children: [{
								value: '17',
								label: '通知'
							},
							{
								value: '34',
								label: '人工'
							},
							{
								value: '35',
								label: 'AI'
							}
						]
					},
					{
						value: '',
						label: '会员营销（回访）',
						children: [{
								value: '36',
								label: '纯回访，无营销性质'
							},
							{
								value: '37',
								label: '浏览过回访营销'
							},
							{
								value: '38',
								label: '注册会员营销'
							}
						]
					},
					{
						value: '',
						label: '通知/验证',
						children: [{
								value: '21',
								label: '通知'
							},
							{
								value: '1',
								label: '验证'
							},
							{
								value: '22',
								label: '问卷调查'
							},
							{
								value: '3',
								label: '语音验证码'
							}
						]
					},
					{
						value: '',
						label: '房产',
						children: [{
								value: '5',
								label: '新房'
							},
							{
								value: '18',
								label: '二手房'
							}
						]
					},
					{
						value: '',
						label: '食药、保健品',
						children: [{
								value: '12',
								label: '精准+复购'
							},
							{
								value: '15',
								label: '盲呼 '
							}
						]
					},
					{
						value: '',
						label: '医美、护肤瘦身、美容美发',
						children: [{
								value: '39',
								label: '精准+复购'
							},
							{
								value: '40',
								label: '盲呼 '
							}
						]
					},
					{
						value: '',
						label: '医疗器械',
						children: [{
								value: '41',
								label: '精准+复购'
							},
							{
								value: '42',
								label: '盲呼 '
							}
						]
					},
					{
						value: '',
						label: '婚恋、交友',
						children: [{
								value: '43',
								label: '精准+复购'
							},
							{
								value: '44',
								label: '盲呼 '
							}
						]
					},
					{
						value: '',
						label: '酒水、烟草 ',
						children: [{
							value: '45',
							label: '精准+复购'
						}]
					},
					{
						value: '',
						label: '汽车',
						children: [{
								value: '46',
								label: '新车'
							},
							{
								value: '47',
								label: '二手车'
							}
						]
					},
					{
						value: '',
						label: '装修',
						children: [{
								value: '48',
								label: '家装'
							},
							{
								value: '49',
								label: '家居建材'
							},
							{
								value: '20',
								label: '电器邀约'
							}
						]
					},
					{
						value: '',
						label: '电商',
						children: [{
							value: '50',
							label: '淘宝商家'
						}, {
							value: '51',
							label: '家政服务'
						}]
					},
					{
						value: '',
						label: '教育培训',
						children: [{
							value: '52',
							label: '成人教育'
						}, {
							value: '8',
							label: '学生类业务'
						}, {
							value: '53',
							label: '其他培训'
						}]
					},
					{
						value: '',
						label: '招商会议',
						children: [{
							value: '19',
							label: '本地线打本地'
						}, {
							value: '54',
							label: '升级套餐业务'
						}]
					},
					{
						value: '',
						label: '招聘类',
						children: [{
							value: '10',
							label: '招聘类'
						}]
					},
					{
						value: '',
						label: '旅游类',
						children: [{
							value: '13',
							label: '旅游类'
						}]
					},
					{
						value: '',
						label: '网购类',
						children: [{
							value: '14',
							label: '网购类'
						}]
					}
				],
				protectionLevel2: [{
						value: '',
						label: '禁用',
						children: [{
							value: '500',
							label: '禁用电话邦'
						}]
					},
					{
						value: '',
						label: 'A+模型',
						children: [{
							value: '24',
							label: 'A+模型'
						}]
					},
					{
						value: '',
						label: '催收',
						children: [{
							value: '2',
							label: '催本人'
						}, {
							value: '32',
							label: '催紧急联系人'
						}, {
							value: '33',
							label: '催三方'
						}]
					},
					{
						value: '',
						label: '金融',
						children: [{
								value: '4',
								label: '贷款（个人）'
							}, {
								value: '11',
								label: 'hy2'
							}, {
								value: '7',
								label: 'hy1'
							}, {
								value: '23',
								label: '信用卡'
							}, {
								value: '16',
								label: 'POS 机 '
							},
							{
								value: '9',
								label: '理财产品'
							}, {
								value: '6',
								label: '保险'
							}
						]
					},
					{
						value: '',
						label: '企业服务',
						children: [{
							value: '31',
							label: '贷款'
						}, {
							value: '30',
							label: '财税、印花税 '
						}, {
							value: '29',
							label: '法律咨询 '
						}]
					},
					{
						value: '',
						label: '游戏',
						children: [{
							value: '17',
							label: '通知'
						}, {
							value: '34',
							label: '人工'
						}, {
							value: '35',
							label: 'AI'
						}]
					},
					{
						value: '',
						label: '会员营销（回访）',
						children: [{
								value: '36',
								label: '纯回访，无营销性质'
							}, {
								value: '37',
								label: '浏览过回访营销'
							},
							{
								value: '38',
								label: '注册会员营销'
							}
						]
					},
					{
						value: '',
						label: '通知/验证',
						children: [{
							value: '21',
							label: '通知'
						}, {
							value: '1',
							label: '验证'
						}, {
							value: '22',
							label: '问卷调查'
						}, {
							value: '3',
							label: '语音验证码'
						}]
					},
					{
						value: '',
						label: '房产',
						children: [{
							value: '5',
							label: '新房'
						}, {
							value: '18',
							label: '二手房'
						}]
					},
					{
						value: '',
						label: '食药、保健品',
						children: [{
							value: '12',
							label: '精准+复购'
						}, {
							value: '15',
							label: '盲呼 '
						}]
					},
					{
						value: '',
						label: '医美、护肤瘦身、美容美发',
						children: [{
							value: '39',
							label: '精准+复购'
						}, {
							value: '40',
							label: '盲呼 '
						}]
					},
					{
						value: '',
						label: '医疗器械',
						children: [{
							value: '41',
							label: '精准+复购'
						}, {
							value: '42',
							label: '盲呼 '
						}]
					},
					{
						value: '',
						label: '婚恋、交友',
						children: [{
							value: '43',
							label: '精准+复购'
						}, {
							value: '44',
							label: '盲呼 '
						}]
					},
					{
						value: '',
						label: '酒水、烟草 ',
						children: [{
							value: '45',
							label: '精准+复购'
						}]
					},
					{
						value: '',
						label: '汽车',
						children: [{
							value: '46',
							label: '新车'
						}, {
							value: '47',
							label: '二手车'
						}]
					},
					{
						value: '',
						label: '装修',
						children: [{
							value: '48',
							label: '家装'
						}, {
							value: '49',
							label: '家居建材'
						}, {
							value: '20',
							label: '电器邀约'
						}]
					},
					{
						value: '',
						label: '电商',
						children: [{
							value: '50',
							label: '淘宝商家'
						}, {
							value: '51',
							label: '家政服务'
						}]
					},
					{
						value: '',
						label: '教育培训',
						children: [{
							value: '52',
							label: '成人教育'
						}, {
							value: '8',
							label: '学生类业务'
						}, {
							value: '53',
							label: '其他培训'
						}]
					},
					{
						value: '',
						label: '招商会议',
						children: [{
							value: '19',
							label: '本地线打本地'
						}, {
							value: '54',
							label: '升级套餐业务'
						}]
					},
					{
						value: '',
						label: '招聘类',
						children: [{
							value: '10',
							label: '招聘类'
						}]
					},
					{
						value: '',
						label: '旅游类',
						children: [{
							value: '13',
							label: '旅游类'
						}]
					},
					{
						value: '',
						label: '网购类',
						children: [{
							value: '14',
							label: '网购类'
						}]
					}
				],

				frequencyList: [{
						value: '',
						label: '三天',
						children: [{
								value: '3',
								label: '3次',
							},
							{
								value: '4',
								label: '4次',
							},
							{
								value: '5',
								label: '5次',
							}
						]
					},
					{
						value: '',
						label: '四天',
						children: [{
								value: '3',
								label: '3次',
							},
							{
								value: '4',
								label: '4次',
							},
							{
								value: '5',
								label: '5次',
							}
						]
					},
					{
						value: '',
						label: '五天',
						children: [{
								value: '3',
								label: '3次',
							},
							{
								value: '4',
								label: '4次',
							},
							{
								value: '5',
								label: '5次',
							}
						]
					}
				],

				companyBatchSystemInterceptionVisible: false,
				companyBatchSystemInterceptionForm: {
					blacklist: true,
					highFrequency: true,
					riskNumber: true,
					ids: '',
				},
				lockVisible: false,
				availableHours: Array.from({
					length: 24
				}, (_, i) => i + 0), // 从08到18的小时数组（注意：这里简化了，没有考虑30分钟的问题）
				filtrationdis: false,
				dhbdis: true,
				yxdis: true,
				content: '',
				contentVisible: false,
				customData: {},
				activeName: 'company',
				query6: {
					agentId: '',
					companyId: '',
					cardsId: '',
					standard: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData7: [],
				tableData6: [],
				pageTotal6: 0,
				query10: {
					name: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData10: [],
				pageTotal10: 0,
				cardMap: '',
				totalStat: '',
				standardList: [{
						value: '联通',
						label: '联通',
					},
					{
						value: '电信',
						label: '电信',
					},
					{
						value: '移动',
						label: '移动',
					}
				],
				cardsList: [],

				activateList: [],
				onlineList: [],
				customDataTotal: '',
				activateDataTotal: '',
				addEnterpriseLevelVisible: false,
				addEnterpriseLevelForm: {
					repeatCall: 1, //重复拨打
					protectionLevel: '', //电话邦等级
					blacklist: true, //共享黑名单
					riskNumber: true, // 共享风险号码
					highFrequency: true, // 共享风险号码
					yxLevel: '三级', //御鑫等级
					lv: '',
					rules: [{
						use1: {
							value: '',
							type: "",
						},
						use2: {
							value: '',
							type: "",
						},
						complaint: '',
					}]
				},
				symbolList: ['>', '>=', '=', '<=', '<'],
				typeList: [{
						value: '1',
						label: '新增',
					},
					{
						value: '2',
						label: '换卡',
					},
					{
						value: '3',
						label: '补卡',
					}
				],
				activationList: [{
						value: "true",
						label: '是',
					},
					{
						value: "false",
						label: '否',
					}
				],
				setMealIdList: [],
				operatorList: [],
				cityList: [],
				pageTotal4: 0,
				query4: {
					userId: localStorage.getItem('user'),
					agentId: '',
					companyId: '',
					cardId: '',
					back: false,
					city: '',
					standard: '',
					setMealId: '',
					batchOpen: '',
					isReport: '',
					startTime: '',
					endTime: '',
					batchNum: '',
					operator: '',
					iccid: '',
					imsi: '',
					phone: '',
					activation: '', //激活
					pageIndex: 1,
					pageSize: 10,
				},

				tableData9: [],
				auditRecordVisible: false,
				pageTotal8: 0,
				statusList: [{
						label: '待审核',
						value: '0',
					},
					{
						label: '审核通过',
						value: '1',
					},
					{
						label: '审核失败',
						value: '-1',
					}
				],
				enableList: [{
						label: '审核通过',
						value: true,
					},
					{
						label: '审核失败',
						value: false,
					}
				],
				backList: [{
						value: true,
						label: '是',
					},
					{
						value: false,
						label: '否',
					}
				],
				uploadVisible: false,
				timeArr: [],
				timeArr2: [],
				frequencyLimitingVisible: false,
				frequencyLimitingForm: {
					standard: '',
					num: '',
				},
				tableData4: [],
				addOutboundVisible: false,
				dialogOutboundVisible: false,
				expressData: [],
				uploadOutboundVisible: false,
				addEnterpriseLevelFormUpdate: false,
				auditVisible: false,
				auditForm: {
					enable: false,
					remark: '',
					id: '',
				},
				tableData12: [],
				query12: {
					agentId: '',
					companyId: '',
					cardsId: '',
					standard: '',
					pageIndex: 1,
					pageSize: 10,
				},
				tableData13: [],
				query13: {
					agentId: '',
					companyId: '',
					cardsId: '',
					standard: '',
					pageIndex: 1,
					pageSize: 10,
				},
				pageTotal13: 0,
				duplicateBlacklistVisible: false, //重复黑名单企业显示
				duplicateBlacklist: [], //重复的黑名单

				provinceData: [],
				dataList: [],
				chart: null,
				resizeHandler: null,
				province: '',
				mapcardsId: '',


				showChildrenVisible: false,
				childrenTableData: [],
				childrenPageTotal: 0,
				query20: {
					pageIndex: 1,
					pageSize: 10,
				},
			};
		},
		watch: {
			'query.agentId'(newVal) {
				this.tableKey++ // 值变化时强制刷新表格
				this.getData();
			}
		},
		beforeUnmount() {
			if (this.resizeHandler) {
				window.removeEventListener('resize', this.resizeHandler);
			}
			if (this.chart) {
				this.chart.dispose();
				this.chart = null;
			}
		},
		computed: {
			multTimeRange() {
				return this.weektimeData.map((item) => {
					return {
						id: item.row,
						week: item.value,
						value: splicing(item.child),
					};
				});
			},
			multTimeRange2() {
				return this.weektimeData2.map((item) => {
					return {
						id: item.row,
						week: item.value,
						value: splicing(item.child),
					};
				});
			},
			selectedCityLabels() {
				return this.callRestrictions.map(value => {
					for (const group of this.allGroups) {
						for (const city of group.children) {
							if (city.value === value) {
								return {
									value,
									label: city.label
								};
							}
						}
					}
					return {
						value,
						label: value
					};
				});
			}

		},
		created() {
			let role = localStorage.getItem('ms_role');
			this.subAgent = localStorage.getItem('subAgent');
			if (role === 'normal') {
				this.canAddCompany = false;
				this.canEditCompany = true;
				this.canRemoveCompany = true;
			}
			if (role === 'company') {
				this.canAddCompany = false;
				this.protectionLevelTrue = true;
				this.canRemoveCompany = true;
				this.iscompany = false;
			}

			if (role === 'agent') {
				this.isNotAdmin = false;
				this.isAgent = true;
				this.isagent = true;
				this.canRemoveCompany = false;
				this.protectionLevelTrue = false;
				this.repeatCallgew = true;
				if (this.subAgent == 'true') {
					this.isSubAgent = true;
					this.getquerySubAgent();
				} else {
					this.isSubAgent = false;
				}
			}
			if (role === 'subAgent') {
				this.isAgent = true;
			}
			if (role === 'admin') {
				this.isAgent = true;
				this.isAdmin = true;
				this.canRemoveCompany = false;
				this.protectionLevelTrue = false;
				this.repeatCallgew = true;
			}
			this.init();
			this.fetchCompanyType();
			this.getOEMagentOem();
			this.getData();
			this.getCitys();
			this.getqueryProvinceCity();
			this.updateTabStyle();
			this.updatePaginationStyle();
		},
		methods: {
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}
				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getCitys() {
				getCity().then(res => {
					this.allGroups = res.data;
					this.initPinyinMap();
					this.filteredGroups = [...this.allGroups];
					this.updateVisibleCount();
				})
			},
			initPinyinMap() {
				this.pinyinMap = {};
				this.allGroups.forEach(group => {
					// 省份拼音
					const provincePinyin = this.getPinyin(group.label);
					const provinceFirstLetters = this.getFirstLetters(group.label);
					this.pinyinMap[group.label] = {
						full: provincePinyin,
						first: provinceFirstLetters
					};
					// 城市拼音
					group.children.forEach(city => {
						const cityPinyin = this.getPinyin(city.label);
						const cityFirstLetters = this.getFirstLetters(city.label);
						this.pinyinMap[city.label] = {
							full: cityPinyin,
							first: cityFirstLetters
						};
					});
				});
			},
			getPinyin(text) {
				try {
					return this.pinyinPro.pinyin(text, {
						toneType: 'none',
						type: 'string'
					}).replace(/\s+/g, '');
				} catch (e) {
					return text;
				}
			},
			getFirstLetters(text) {
				try {
					return this.pinyinPro.pinyin(text, {
						toneType: 'none',
						pattern: 'first',
						type: 'string'
					}).replace(/\s+/g, '');
				} catch (e) {
					return text.charAt(0);
				}
			},
			// 处理搜索
			handleSearch2() {
				if (!this.searchQuery.trim()) {
					this.filteredGroups = [...this.allGroups];
					this.updateVisibleCount();
					return;
				}
				const query = this.searchQuery.toLowerCase();
				const result = [];
				this.allGroups.forEach(group => {
					// 分组匹配：名称/拼音
					const isGroupMatch =
						group.label.includes(query) ||
						(this.pinyinMap[group.label]?.full.includes(query)) ||
						(this.pinyinMap[group.label]?.first.includes(query));
					// 城市匹配
					const matchedCities = group.children.filter(city =>
						city.label.includes(query) ||
						(this.pinyinMap[city.label]?.full.includes(query)) ||
						(this.pinyinMap[city.label]?.first.includes(query))
					);
					// 保留匹配的分组
					if (isGroupMatch || matchedCities.length > 0) {
						result.push({
							...group,
							children: isGroupMatch ? group.children : matchedCities
						});
					}
				});

				this.filteredGroups = result;
			},
			handleSearchcallRestrictions() {
				if (!this.searchQuery) {
					this.filteredGroups = [...this.allGroups];
					this.updateVisibleCount();
					return;
				}
				const query = this.searchQuery.toLowerCase();
				const filtered = [];
				this.allGroups.forEach(group => {
					const groupMatch =
						group.label.includes(query) ||
						(this.pinyinMap[group.label]?.full.includes(query)) ||
						(this.pinyinMap[group.label]?.first.includes(query));
					const children = group.children.filter(city => {
						return (
							city.label.includes(query) ||
							(this.pinyinMap[city.label]?.full.includes(query)) ||
							(this.pinyinMap[city.label]?.first.includes(query))
						);
					});
					if (groupMatch || children.length > 0) {
						filtered.push({
							...group,
							children: children
						});
					}
				});
				this.filteredGroups = filtered;
				this.updateVisibleCount();
			},
			updateVisibleCount() {
				this.visibleCityCount = this.filteredGroups.reduce((sum, group) => sum + group.children.length,
					0);
			},
			handleSelectChange(selected) {
				this.callRestrictions = selected;
			},
			clearWeektime() {
				this.weektimeData.forEach((item) => {
					item.child.forEach((t) => {
						t.check = false;
					});
				});
			},
			allWeektime() {
				this.weektimeData.forEach((item) => {
					item.child.forEach((t) => {
						t.check = true;
					});
				});
			},

			clearWeektime2() {
				this.weektimeData2.forEach((item) => {
					item.child.forEach((t) => {
						t.check = false;
					});
				});
			},
			allWeektime2() {
				this.weektimeData2.forEach((item) => {
					item.child.forEach((t) => {
						t.check = true;
					});
				});
			},
			showRatingForm() {
				// 确保至少有一个ID存在再执行操作
				if (this.query.companyId || this.query.agentId) {
					const data = this.query.companyId ? {
						companyId: this.query.companyId
					} : {
						agentId: this.query
							.agentId
					};
					enterpriseManualRating(data).then(res => {
						if (res?.code === 200) {
							this.getData(); // 重新获取数据
						} else {
							// 显示具体错误信息
							this.$message.error(res?.message || '操作失败，请重试');
						}
					}).catch(error => {
						// 添加错误捕获
						this.$message.error('请求失败: ' + (error.message || '未知错误'));
					});
				} else {
					// 添加明确的用户提示
					this.$message.error('请先选择公司或代理');
				}
			},

			//获取品牌
			getCardType() {
				getCardType().then(res => {
					this.cardsList = res.data;
				})
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'company') {
					this.query.companyId = '';
					this.query.agentId = null;
					this.query4.companyId = '';
					this.query4.agentId = '';
					this.query6.companyId = '';
					this.query6.agentId = '';
					this.pageTotal = 0;
					this.tableData = [];
					this.init();
					this.fetchCompanyType();
					this.getOEMagentOem();
					this.getData();
				} else if (tab.props.name == 'onTheInternet') {
					this.query.companyId = '';
					this.query.agentId = null;
					this.query4.companyId = '';
					this.query4.agentId = '';
					this.query6.agentId = '';
					this.query6.companyId = '';
					this.init();
					this.getCardType();
					this.getcompanyUseData();
				} else if (tab.props.name == 'areasDistribution') {
					//归属地分布
					this.getCardType();
					this.getqueryProvinceCity();
				} else if (tab.props.name == 'outboundRecord') {
					this.query.companyId = '';
					this.query.agentId = null;
					this.query4.companyId = '';
					this.query4.agentId = '';
					this.query6.companyId = '';
					this.query6.agentId = '';
					this.init();
					this.getSetMealList();
					this.getDeliveryOperator();
					this.getDeliveryCity();
					this.getCardType();
					this.getOutboundData();
				} else if (tab.props.name == 'agentGrade') {
					this.getcompanyRulesSettingList()
				} else if (tab.props.name == 'enterpriseBlacklist') {
					this.getEnterpriseBlacklist()
				} else if (tab.props.name == 'onLineInternet') {
					this.query12.companyId = '';
					this.query12.agentId = '';
					this.init();
					this.getCardType();
					this.getTime2();
					this.getActivateRecordlist()

				} else if (tab.props.name == 'activationDetails') {
					this.query13.companyId = '';
					this.query13.agentId = '';
					this.init();
					this.getCardType();
					this.getTime2();
					this.getactivateInfo()
				}
			},
			getcompanyUseData() {
				if (!this.query6.agentId) {
					this.query6.pageSize = 3000;
				} else {
					this.query6.pageSize = 30;
				}
				let data = {
					agentId: this.query6.agentId,
					companyId: this.query6.companyId,
					cardsId: this.query6.cardsId,
					standard: this.query6.standard,
					pageIndex: this.query6.pageIndex,
					pageSize: this.query6.pageSize,
				}
				this.loading = true;
				companyUseData(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData6 = res.data.list;
						this.pageTotal6 = res.data.total;
						const safeCustomData = Array.isArray(res.customData) ? res.customData : [];
						this.customDataTotal = safeCustomData.reduce((acc, item) => {
							acc.totalCount += item.total || 0; // 额外防止 item.total 未定义
							return acc;
						}, {
							totalCount: 0,
						});
						this.onlineList = res.customData || [];
					} else {
						this.$message.error(res.message);
					}
				});
			},


			showChildrens(row, column) {
				this.showChildrenVisible = true;
				this.query20.pageIndex = 1;
				this.query20.companyId = row.id;
				let data = {
					companyId: this.query20.companyId,
					cardsId: this.query6.cardsId,
					standard: this.query6.standard,
					pageIndex: this.query20.pageIndex,
					pageSize: this.query20.pageSize,
				}
				this.loading = true;
				companyUseInfo(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.childrenTableData = res.data.list;
						this.childrenPageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getCompanyUseInfoDownload() {
				let data = {
					companyId: this.query20.companyId,
					cardsId: this.query6.cardsId,
					standard: this.query6.standard,
					pageIndex: this.query20.pageIndex,
					pageSize: this.query20.pageSize,
				}
				companyUseInfoDownload(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '企业在网详情' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
			// 分页导航
			handlePageChange2(val) {
				this.query20.pageIndex = val;
				let data = {
					companyId: this.query20.companyId,
					cardsId: this.query6.cardsId,
					standard: this.query6.standard,
					pageIndex: this.query20.pageIndex,
					pageSize: this.query20.pageSize,
				}
				this.loading = true;
				companyUseInfo(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.childrenTableData = res.data.list;
						this.childrenPageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleSizeChange2(val) {
				this.query20.pageIndex = 1; // 重置到第一页
				this.query20.pageSize = val;
				let data = {
					companyId: this.query20.companyId,
					cardsId: this.query6.cardsId,
					standard: this.query6.standard,
					pageIndex: this.query20.pageIndex,
					pageSize: this.query20.pageSize,
				}
				this.loading = true;
				companyUseInfo(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.childrenTableData = res.data.list;
						this.childrenPageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(() => {
					// 直接调用 Element UI 的 focus 方法
					if (this.$refs.saveTagInput) {
						this.$refs.saveTagInput.focus();
					}
				});
			},
			handleInputConfirm() {
				const inputValue = this.inputValue.trim();
				if (inputValue) {
					// 防御性判断，确保是数组
					if (!Array.isArray(this.form.city)) {
						this.form.city = [];
					}
					this.form.city.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			handleClose(tag) {
				this.form.city = this.form.city.filter(t => t !== tag);
			},
			getAddDelivery() {
				this.uploadOutboundVisible = true;
			},
			uploadformClose() {
				this.uploadOutboundVisible = false;
			},
			submitOutboundUpload() {
				if (this.$refs.uploadOutbound.uploadFiles[0]) {
					this.$refs.uploadOutbound.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			gtecompanyLvLog(row) {
				let data = {
					companyId: row.id,
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user')
				}
				this.contentVisible = true;
				this.loading = true;
				companyLvLog(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData3 = res.data.list;

					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog3() {
				this.contentVisible = false;
			},
			yxLevelChang(e) {
				if (e == '1') {
					this.form.yxLevel = '一级';
				} else if (e == '2') {
					this.form.yxLevel = '二级';
				} else if (e == '3') {
					this.form.yxLevel = '三级';
				} else if (e == '4') {
					this.form.yxLevel = '四级';
				} else if (e == '5') {
					this.form.yxLevel = '五级';
				}
			},
			yxLevelChang2(e) {
				if (e == '1') {
					this.query.yxLevel = '一级';
				} else if (e == '2') {
					this.query.yxLevel = '二级';
				} else if (e == '3') {
					this.query.yxLevel = '三级';
				} else if (e == '4') {
					this.query.yxLevel = '四级';
				} else if (e == '5') {
					this.query.yxLevel = '五级';
				}
			},
			getfiltration(e) {
				if (e.includes('non')) {
					this.form.filtration = ['non']
					this.addEnterpriseLevelForm.filtration = ['non']
					this.filtrationdis = true;
					this.dhbdis = true;
					this.yxdis = true;
				} else {
					if (e.includes('dhb')) {
						this.dhbdis = false;
						this.filtrationdis = false;
					} else {
						this.dhbdis = true;
						this.filtrationdis = true;
					}
					if (e.includes('yx')) {
						this.yxdis = false;
						this.filtrationdis = false;
					} else {
						this.yxdis = true;
						this.filtrationdis = true;
					}
					this.form.filtration = e;
				}
			},
			formatHour(hour) {
				const minutes = this.startTimeHour === hour && this.startTimeMinute === 30 ? '30' : '00';
				return `${hour < 10 ? '0' : ''}${hour}:${minutes}`;
			},

			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (res?.code === 200) {
						this.companys = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getquerySubAgent() {
				let data = {
					agentId: this.query.agentId,
					userId: localStorage.getItem('user')
				};
				querySubAgent(data).then(res => {
					if (res?.code === 200) {
						this.subAgentList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getOEMagentOem() {
				// let url = 'crm.jilinlingshang.com';// 如果改领尚 切换当前的
				let url = window.location.host; // 如果改云企通 切换当前的
				// let url = 'cytx88.cn';//如果改橙逸 切换当前
				getOemInfo(url)
					.then(res => {
						if (res?.code === 200) {
							this.webInfo = res.data;
							let linkicon = document.querySelector("link[rel*='icon']") || document
								.createElement(
									'link');
							linkicon.href = res.data.icon;
							localStorage.setItem('webName', res.data.webName);
						} else {
							this.$message.error('查询失败，请稍后再试！');
						}
					})
					.catch(err => {
						this.$message.error('查询失败，请稍后再试！');
					});
			},
			httprequest(req) {
				this.config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				};
				this.keyname = 'lytton' + new Date() + Math.floor(Math.random() * 100) + '.';
			},
			fetchCompanyType() {
				fetchCompanyType().then(res => {
					if (res?.code === 200) {
						this.businessTypeList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 删除照片
			handleRemove1(file, fileList) {
				this.hideUpload1 = fileList.length >= this.limitCount;
				this.form.businessLicense = '';
			},
			handleRemove2(file, fileList) {
				this.hideUpload2 = fileList.length >= this.limitCount;
				this.form.idcardFront = '';
			},
			handleRemove3(file, fileList) {
				this.hideUpload3 = fileList.length >= this.limitCount;
				this.form.idcardReverse = '';
			},
			handleRemove4(file, fileList) {
				this.hideUpload4 = fileList.length >= this.limitCount;
				this.form.legalPersonPhotos = '';
			},
			handleRemove5(file, fileList) {
				this.hideUpload5 = fileList.length >= this.limitCount;
				this.form.template1 = '';
			},
			handleRemove6(file, fileList) {
				this.hideUpload6 = fileList.length >= this.limitCount;
				this.form.template2 = '';
			},
			handleRemove7(file, fileList) {
				this.hideUpload7 = fileList.length >= this.limitCount;
				this.form.template3 = '';
			},
			handleRemove8(file, fileList) {
				this.hideUpload8 = fileList.length >= this.limitCount;
				this.form.template4 = '';
			},
			handleRemove9(file, fileList) {
				this.hideUpload9 = fileList.length >= this.limitCount;
				this.form.template5 = '';
			},
			//查看大图
			handlePictureCardPreview1(file) {
				this.dialogImageUrl1 = file.url;
				this.addVisible1 = true;
			},
			handlePictureCardPreview2(file) {
				this.dialogImageUrl2 = file.url;
				this.addVisible2 = true;
			},
			handlePictureCardPreview3(file) {
				this.dialogImageUrl3 = file.url;
				this.addVisible3 = true;
			},
			handlePictureCardPreview4(file) {
				this.dialogImageUrl4 = file.url;
				this.addVisible4 = true;
			},
			handlePictureCardPreview5(file) {
				this.dialogImageUrl5 = file.url;
				this.addVisible5 = true;
			},
			handlePictureCardPreview6(file) {
				this.dialogImageUrl6 = file.url;
				this.addVisible6 = true;
			},
			handlePictureCardPreview7(file) {
				this.dialogImageUrl7 = file.url;
				this.addVisible7 = true;
			},
			handlePictureCardPreview8(file) {
				this.dialogImageUrl8 = file.videoUrl;
				// this.getBase64(file.raw).then(res => {
				// 	this.dialogImageUrl8 = res;
				// });
				this.addVisible8 = true;
			},
			handlePictureCardPreview9(file) {
				this.dialogImageUrl9 = file.videoUrl;
				// this.getBase64(file.raw).then(res => {
				// 	this.dialogImageUrl9 = res;
				// });
				this.addVisible9 = true;
			},

			handleUploadSuccess(response, file, fileList) {
				//为 el-upload on-success 方法实现
				this.fileList = fileList;
				if (response.code != 0) {
					this.$message({
						message: '附件上传失败',
						type: 'error'
					});
					this.fileList.splice(this.fileList.indexOf(file, 1));
				} else {
					let _fileName = file.name;
					if (this.$utils.getFileIsVideo(_fileName)) {
						//getFileIsVideo 为我本地自定义判断是否是视频方法，可自己修改
						//视频附件，获取第一帧画面作为 封面展示
						this.getVideoCover(file);
					}
				}
			},

			// 上传照片后隐藏上传按钮
			beformRemove1(file, fileList) {
				return new Promise((resolve, reject) => {
					this.$confirm('确定要删除这张图片吗？', '提示', {
						type: 'warning',
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(() => {
						resolve(true) // 确认删除
					}).catch(() => {
						reject(false) // 取消删除
					})
				})
			},

			beformRemove2(fileList) {
				return new Promise((resolve, reject) => {
					this.$confirm('确定要删除这个视频吗？', '提示', {
						type: 'warning',
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					}).then(() => {
						resolve(true) // 确认删除
					}).catch(() => {
						reject(false) // 取消删除
					})
				})
			},
			// 传营业执照
			getbusinessLicense(file, fileList) {
				this.hideUpload1 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.businessLicense = res;
				});
			},
			// 传身份证正面
			getIDCardFront(file, fileList) {
				this.hideUpload2 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.idcardFront = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 传身份证反面
			getIDCardReverse(file, fileList) {
				this.hideUpload3 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.idcardReverse = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 传法人照片
			getlegalPersonPhotos(file, fileList) {
				this.hideUpload4 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.legalPersonPhotos = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 传话术磨板1
			gettemplate1(file, fileList) {
				this.hideUpload5 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.template1 = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 传话术磨板2
			gettemplate2(file, fileList) {
				this.hideUpload6 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.template2 = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 传话术磨板3
			gettemplate3(file, fileList) {
				this.hideUpload7 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.template3 = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
			},
			// 在获取到后台返回的视频地址后调用

			async setVideoCoverFromUrl(videoUrl) {
				try {
					const coverUrl = await this.generateCoverFromVideoUrl(videoUrl);
					this.fileList8 = [{
						name: '办公场景视频',
						url: coverUrl, // 显示封面
						videoUrl: videoUrl, // 保存原始视频地址
						isRemote: true // 标记为远程视频
					}];
				} catch (error) {
					console.error('生成远程视频封面失败:', error);
					// 使用默认封面
					this.fileList8 = [{
						name: '办公场景视频',
						url: this.defaultCoverUrl,
						videoUrl: videoUrl,
						isRemote: true
					}];
				}
			},
			// 办公场景视频
			async gettemplate4(file, fileList) {
				this.hideUpload8 = fileList.length >= this.limitCount;
				this.getBase64(file.raw).then(res => {
					this.form.template4 = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
				if (file.raw && file.raw.type.startsWith('video/')) {
					try {
						// 生成视频封面
						const coverUrl = await this.generateVideoCover(file.raw);
						file.coverUrl = coverUrl; // 保存封面URL
						// 创建视频预览URL
						const videoUrl = URL.createObjectURL(file.raw);
						file.url = videoUrl;
						this.fileList8 = [{
							name: file.name,
							url: coverUrl,
							raw: file.raw
						}]
					} catch (error) {
						console.error('生成视频封面失败:', error);
						// 使用默认封面
						file.coverUrl = this.defaultCoverUrl;
					}
				}
			},

			// 告知书
			async gettemplate5(file, fileList) {
				this.hideUpload9 = fileList.length >= this.limitCount;
				console.log(file, 'file.rawfile.rawfile.raw')
				this.getBase64(file.raw).then(res => {
					this.form.template5 = res;
					const params = res.split(',');
					if (params.length > 0) {
						this.strimagebase64 = params[1];
					}
				});
				if (file.raw && file.raw.type.startsWith('video/')) {
					try {
						// 生成视频封面
						const coverUrl = await this.generateVideoCover(file.raw);
						file.coverUrl = coverUrl; // 保存封面URL

						// 创建视频预览URL
						const videoUrl = URL.createObjectURL(file.raw);
						file.url = videoUrl;
						this.fileList9 = [{
							name: file.name,
							url: coverUrl,
							raw: file.raw
						}]
					} catch (error) {
						console.error('生成视频封面失败:', error);
						// 使用默认封面
						file.coverUrl = this.defaultCoverUrl;
					}
				}
			},
			// 生成视频封面
			generateVideoCover(videoFile) {
				return new Promise((resolve, reject) => {
					const video = document.createElement('video');
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');
					video.src = URL.createObjectURL(videoFile);
					video.crossOrigin = 'anonymous';
					video.onloadeddata = () => {
						// 设置 canvas 尺寸为视频尺寸
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						// 跳到第一帧并绘制
						video.currentTime = 1; // 稍微跳过开头避免黑帧
					};
					video.onseeked = () => {
						// 绘制视频帧到 canvas
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						// 将 canvas 转换为图片 URL
						const coverUrl = canvas.toDataURL('image/jpeg');
						// 清理
						URL.revokeObjectURL(video.src);
						resolve(coverUrl);
					};
					video.onerror = reject;
					video.load();
				});
			},

			closeDialogdialogImageUrl9() {
				this.dialogImageUrl9 = '';
				this.addVisible9 = false;
			},
			closeDialogdialogImageUrl8() {
				this.dialogImageUrl8 = '';
				this.addVisible8 = false;
			},
			// 转图片转vase64
			getBase64(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					let imgResult = '';
					reader.readAsDataURL(file);
					reader.onload = function() {
						imgResult = reader.result;
					};
					reader.onerror = function(error) {
						reject(error);
					};
					reader.onloadend = function() {
						resolve(imgResult);
					};
				});
			},

			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				if (this.subAgent == true) {
					this.isSubAgent = true;
					this.getquerySubAgent();
				}
				this.getfetchDefaultCompanies();
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query4.agentId = agentId;
				this.query6.agentId = agentId;
				this.query.companyId = '';
				this.query4.companyId = '';
				this.query6.companyId = '';
				this.query.departmentId = '';
				this.query4.departmentId = '';
				this.query6.departmentId = '';
				this.form.agentId = agentId;
				this.form.companyId = '';
				this.form.departmentId = '';
				this.form.userId = '';
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				}
			},

			getData() {
				this.query.currentUserId = localStorage.getItem('user');
				let yxLevelReverseMap = {
					'一级': '1',
					'二级': '2',
					'三级': '3',
					'四级': '4',
					'五级': '5'
				};

				// 去除空格 + 确保 key 存在，否则回退
				let normalizedLevel = String(this.query.yxLevel).trim();
				this.query.yxLevel = yxLevelReverseMap[normalizedLevel] || this.query.yxLevel;
				list(this.query).then(res => {
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
						let yxLevelMap = {
							1: '一级',
							2: '二级',
							3: '三级',
							4: '四级',
							5: '五级'
						};
						// 确保 key 是字符串或数字，取决于实际数据类型
						this.query.yxLevel = yxLevelMap[this.query.yxLevel] ||
							yxLevelMap[Number(this.query.yxLevel)] ||
							this.query.yxLevel;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showForm() {
				this.addVisible = true;
				this.addButton = true;
				this.updateButton = false;
				this.form = {
					name: '',
					code: '',
					businessType: '',
					businessLicense: null,
					idcardFront: null,
					idcardReverse: null,
					legalPersonPhotos: null,
					template1: null,
					template2: null,
					template3: null,
					template4: null,
					template5: null,
					ownerName: '',
					ownerPhone: '',
					classification: '',
					protectionLevel: '0',
					desensitization: false,
					repeat: true, //是否去重
					export: false, //是否导出
					repeatCall: 1, //是否重复拨打
					blacklist: true, //共享黑名单
					riskNumber: true, // 共享风险号码
					frequency: '',
					highFrequency: true, //高频开启
					applet: true,
					department: true,
					automaticCall: true,
					locked: false,
					zxRecordIng: false,
					aiQuality: '全检',
					currentUserId: "",
					filtration: [], //过滤方式
					yxLevel: '三级', //御鑫等级
					city: [],
				};
			},
			joinArray(array) {
				return array.length > 0 ? array.join(',') : array;
			},
			// 点击确定上传信息
			addCompany(formName) {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.loading1 = true;
						this.form.currentUserId = localStorage.getItem('user');
						let qualityMap = {
							'不质检': 0,
							'全检': 5,
						};
						this.form.aiQuality = qualityMap[this.form.aiQuality] || this.form.aiQuality;
						this.form.filtration = this.joinArray(this.form.filtration);
						if (this.form.city) {
							this.form.city = this.form.city.join(',');
						}
						let yxLevelMap = {
							'一级': '1',
							'二级': '2',
							'三级': '3',
							'四级': '4',
							'五级': '5'
						};

						this.form.callRestrictions = this.callRestrictions.join(',');
						this.form.yxLevel = yxLevelMap[this.form.yxLevel] || this.form.yxLevel;
						this.form.callTime = JSON.stringify(this.multTimeRange);
						addCompany(this.form).then(res => {
							if (res?.code === 200) {
								this.addVisible = false;
								this.$message.success('添加成功');
								this.loading1 = false;
								this.$refs.upload1.clearFiles();
								this.$refs.upload2.clearFiles();
								this.$refs.upload3.clearFiles();
								this.$refs.upload4.clearFiles();
								this.$refs.upload5.clearFiles();
								this.$refs.upload6.clearFiles();
								this.$refs.upload7.clearFiles();
								this.$refs.upload8.clearFiles();
								this.$refs.upload9.clearFiles();
								this.getData();
							} else {
								this.$message.error(res.message);
							}
							this.loading1 = false;

						});
					} else {
						this.$message.error('请检查必填项!');
					}
				})

			},
			isNotEmpty(str) {
				return str && str.trim().length > 0;
			},
			// 编辑操作
			handleEdit(index, id) {
				this.addVisible = true;
				this.idx = index;
				this.addButton = false;
				this.updateButton = true;
				// 获取详情
				if (!index && !id) return;
				fetchCompanyById(id).then(res => {
					if (res?.code === 200) {
						// 1. 处理文件列表（动态生成 fileList 和 hideUpload）
						let fileFields = [{
								key: 'businessLicense',
								fileList: 'fileList1',
								hideUpload: 'hideUpload1'
							},
							{
								key: 'idcardFront',
								fileList: 'fileList2',
								hideUpload: 'hideUpload2'
							},
							{
								key: 'idcardReverse',
								fileList: 'fileList3',
								hideUpload: 'hideUpload3'
							},
							{
								key: 'legalPersonPhotos',
								fileList: 'fileList4',
								hideUpload: 'hideUpload4'
							},
							{
								key: 'template1',
								fileList: 'fileList5',
								hideUpload: 'hideUpload5'
							},
							{
								key: 'template2',
								fileList: 'fileList6',
								hideUpload: 'hideUpload6'
							},
							{
								key: 'template3',
								fileList: 'fileList7',
								hideUpload: 'hideUpload7'
							},
							{
								key: 'template4',
								fileList: 'fileList8',
								hideUpload: 'hideUpload8'
							},
							{
								key: 'template5',
								fileList: 'fileList9',
								hideUpload: 'hideUpload9'
							}
						];
						fileFields.forEach(field => {
							if (res.data[field.key]) {
								this[field.fileList] = [{
									url: `https://${res.data[field.key]}`
								}];
								this[field.hideUpload] = this[field.fileList].length >= this.limitCount;
							}
						});
						// 2. 处理表单数据
						this.form = res.data;
						if (this.hideUpload8) {
							this.fileList8 = [{
								name: '办公场景视频',
								url: 'https://img95.699pic.com/xsj/0c/zv/p9.jpg!/fh/300', // 使用默认封面
								videoUrl: 'https://' + this.form.template4, // 视频真实地址
							}];
						}
						if (this.hideUpload9) {
							this.fileList9 = [{
								name: '告知书',
								url: 'https://img95.699pic.com/xsj/0c/zv/p9.jpg!/fh/300', // 使用默认封面
								videoUrl: 'https://' + this.form.template5, // 视频真实地址
							}];
						}
						// 3. 处理城市数据（逗号分隔转数组）
						this.form.city = res.data.city ? res.data.city.split(',') : [];
						// 4. 定义反向映射表
						let aiQualityMapReverse = {
							0: '不质检',
							5: '全检',
						};
						let yxLevelMapReverse = {
							'1': '一级',
							'2': '二级',
							'3': '三级',
							'4': '四级',
							'5': '五级'
						};
						// 5. 处理 callTime 和 callRestrictions
						if (this.form.callTime) {
							this.weektimeData2 = handleData(JSON.parse(this.form.callTime));
						}
						this.callRestrictions = this.form.callRestrictions ? this.form.callRestrictions.split(
							',') : null;
						// 6. 转换 aiQuality 和 yxLevel
						this.form.aiQuality = aiQualityMapReverse[this.form.aiQuality] || this.form.aiQuality;
						this.form.yxLevel = yxLevelMapReverse[this.form.yxLevel] || this.form.yxLevel;
						// 7. 处理 filtration 字段
						if (this.form.filtration) {
							this.form.filtration = this.form.filtration.split(',');
							this.dhbdis = !this.form.filtration.includes('dhb');
							this.yxdis = !this.form.filtration.includes('yx');
						}
						// 8. 其他字段处理
						this.form.protectionLevel = String(this.form.protectionLevel);
						this.repeatText = this.form.repeat ? '号码去重' : '号码不去重';
						this.form.applet = this.form.applet ?? true; // 如果为 null/undefined，默认设为 true
					} else {
						this.$message.error('获取失败');
					}
				});
			},

			// 点击修改信息
			updateCompany() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.loading2 = true;
						// 使用映射对象简化条件判断
						// 映射表
						let aiQualityMap = {
							'不质检': 0,
							'全检': 5,
						};
						let yxLevelMap = {
							'一级': '1',
							'二级': '2',
							'三级': '3',
							'四级': '4',
							'五级': '5'
						};
						// 处理 aiQuality（支持字符串或数字输入）
						let validAiQualities = [0, 5, 10, 20];
						if (typeof this.form.aiQuality === "string") {
							// 尝试从映射表获取，或解析纯数字字符串
							this.form.aiQuality = aiQualityMap[this.form.aiQuality] ??
								(validAiQualities.includes(Number(this.form.aiQuality)) ? Number(this.form
									.aiQuality) : 5);
						} else if (typeof this.form.aiQuality === "number") {
							// 确保数值合法
							this.form.aiQuality = validAiQualities.includes(this.form.aiQuality) ? this.form
								.aiQuality : 0;
						} else {
							this.form.aiQuality = 5; // 默认值
						}
						// 处理 yxLevel（直接映射）
						this.form.yxLevel = yxLevelMap[this.form.yxLevel] || this.form
							.yxLevel; // 防止未匹配时保持原值（或可设默认值）
						// 处理数组转字符串
						this.form.filtration = this.form.filtration?.join(',') || ''; // 安全处理可能的 undefined
						this.form.city = this.form.city?.join(',') || '';
						this.form.callRestrictions = this.callRestrictions?.join(',') || '';
						// 处理时间范围
						this.form.callTime = JSON.stringify(this.multTimeRange2 || {});
						// 设置当前用户
						this.form.currentUserId = localStorage.getItem('user') || '';
						updateCompany(this.form).then(res => {
							this.loading2 = false; // 无论成功或失败，都先设置 loading2 为 false
							if (res?.code === 200) {
								this.addVisible = false;
								this.$message.success('修改成功');
								this.getData();
								// 重置显示状态
								this.filtrationdis = false;
								this.dhbdis = true;
								this.yxdis = true;
							} else {
								this.$message.error(res.message);
							}
							// 重置表单部分字段
							this.form.filtration = [];
						});
					} else {
						this.$message.error('请检查必填项!');
					}
				})
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			// 删除操作
			handleDelete(index, id) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						this.$confirm('删除后数据将无法修复!!!', '提示', {
								type: 'warning'
							})
							.then(() => {
								let data = {
									id: id,
									userId: localStorage.getItem('user')
								};
								delCompany(data).then(res => {
									if (res?.code === 200) {
										this.$message.success('删除成功');
										this.getData();
									} else {
										this.$message.error(res.message);
									}
								});
							})
							.catch(() => {});
					})
					.catch(() => {});
			},

			handleSizeChange(val) {
				let actions = {
					company: () => {
						this.query.pageSize = val;
						this.query.pageIndex = 1;
						this.getData();
					},
					onTheInternet: () => {
						this.query6.pageSize = val;
						this.query6.pageIndex = 1;
						this.getcompanyUseData();
					},
					areasDistribution: () => this.getmyChart(),
					outboundRecord: () => {
						this.query4.pageSize = val;
						this.query4.pageIndex = 1;
						this.getOutboundData();
					},

					enterpriseBlacklist: () => {
					this.query10.pageSize = val;
					this.query10.pageIndex = 1;
					this.getEnterpriseBlacklist();
				},
				onLineInternet: () => {
					this.query12.pageSize = val;
					this.query12.pageIndex = 1;
					this.getActivateRecordlist();
				},
				activationDetails: () => {
					this.query13.pageSize = val;
					this.query13.pageIndex = 1;
					this.getactivateInfo()
				},

				};
				if (actions[this.activeName]) {
					actions[this.activeName]();
				}
			},
			// 分页导航
			handlePageChange(val) {
				let actionMap = {
					company: () => {
						this.query.pageIndex = val;
						this.getData();
					},
					onTheInternet: () => {
						this.query6.pageIndex = val;
						this.getcompanyUseData();
					},
					areasDistribution: () => {
						this.query6.pageIndex = val;
						this.getmyChart();
					},
					outboundRecord: () => {
						this.query4.pageIndex = val;
						this.getOutboundData();
					},

					enterpriseBlacklist: () => {
					this.query10.pageIndex = val;
					this.getEnterpriseBlacklist();
				},
				onLineInternet: () => {
					this.query12.pageIndex = val;
					this.getActivateRecordlist();
				},
				activationDetails: () => {
					this.query13.pageIndex = val;
					this.getactivateInfo()
				},
				};
				// 执行对应的逻辑
				if (actionMap[this.activeName]) {
					actionMap[this.activeName]();
				}

			},
			resetForm(formName) {
				if (this.$refs[formName]) {
					this.$refs[formName].resetFields();
				}
			},
			// 点击取消
			closeDialog(formName) {
				this.$refs.upload1.clearFiles();
				this.$refs.upload2.clearFiles();
				this.$refs.upload3.clearFiles();
				this.$refs.upload4.clearFiles();
				this.$refs.upload5.clearFiles();
				this.$refs.upload6.clearFiles();
				this.$refs.upload7.clearFiles();
				this.$refs.upload8.clearFiles();
				this.$refs.upload9.clearFiles();
				this.hideUpload1 = false;
				this.hideUpload2 = false;
				this.hideUpload3 = false;
				this.hideUpload4 = false;
				this.hideUpload5 = false;
				this.hideUpload6 = false;
				this.hideUpload7 = false;
				this.hideUpload8 = false;
				this.hideUpload9 = false;
				this.addVisible = false;
				(this.form = {
					name: '',
					code: '',
					businessType: '',
					businessLicense: null,
					idcardFront: null,
					idcardReverse: null,
					legalPersonPhotos: null,
					template1: null,
					template2: null,
					template3: null,
					template4: null,
					template5: null,
					ownerName: '',
					ownerPhone: '',
					classification: '',
					protectionLevel: '0',
					desensitization: false,
					repeat: true, //是否去重
					export: false, //是否导出
					repeatCall: 1, //是否重复拨打
					blacklist: true, //共享黑名单
					riskNumber: true, // 共享风险号码
					frequency: '',
					highFrequency: true, //高频开启
					applet: true,
					automaticCall: true,
					department: true,
					locked: false,
					zxRecordIng: false,
					aiQuality: '质检',
					currentUserId: "",
					filtration: [], //过滤方式
					yxLevel: '三级', //御鑫等级
					city: [],
				}),
				this.resetForm(formName);
			},
			handleChange1(value) {
				this.query.protectionLevel = value[1];

			},
			handleChange(value) {
				this.form.protectionLevel = value[1];
				this.addEnterpriseLevelForm.protectionLevel = value[1];
			},
			frequencyhandleChange(value) {
				this.form.frequencyList = value[1];
			},

			getswitch(e) {
				this.isrepeatBox = !e;
				this.repeatText = e ? '号码去重' : '号码不去重';
			},
			getappletswitch(e) {
				this.form.applet = e;
			},

			getswitchenable(row) {
				let data = {
					companyId: row.id,
					enable: row.enable
				};
				updateEnable(data).then(res => {
					if (res?.code === 200) {
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},

			setRepeatMode(isRepeat) {
				this.isrepeatBox = false; // 关闭选择框
				this.repeatText = isRepeat ? '号码去重' : '号码不去重';
				this.form.repeat = isRepeat;
			},
			showCompanyBatchSystemInterception() {
				this.ids = this.multipleSelection.map(item => item?.id).filter(id => id != null).join(',');
				if (!this.ids || this.ids.length === 0) {
					this.$message.error(`请选择需要设置的企业`);
					return;
				}
				this.companyBatchSystemInterceptionVisible = true;
			},
			getCompanyBatchSystemInterception() {
				let data = {
					blacklist: this.companyBatchSystemInterceptionForm.blacklist,
					highFrequency: this.companyBatchSystemInterceptionForm.highFrequency,
					riskNumber: this.companyBatchSystemInterceptionForm.riskNumber,
					ids: this.ids,
				}
				companyBatchSystemInterception(data).then(res => {
					if (res?.code === 200) {
						this.getData();
						this.ids = [];
						this.multipleSelection = [];
						this.companyBatchSystemInterceptionVisible = false;
						this.$message.success(res.data);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closecompanyBatchSystemInterceptionDialog() {
				this.companyBatchSystemInterceptionForm.blacklist = true;
				this.companyBatchSystemInterceptionForm.highFrequency = true;
				this.companyBatchSystemInterceptionForm.riskNumber = true;
				this.companyBatchSystemInterceptionForm.ids = '';
				this.companyBatchSystemInterceptionVisible = false;
			},
			getLock() {
				this.ids = this.multipleSelection.map(item => item?.id).filter(id => id != null).join(',');
				if (!this.ids || this.ids.length === 0) {
					this.$message.error(`请选择需要锁定的企业`);
					return;
				}
				this.lockVisible = true;
			},
			getLocks() {
				let data = {
					userId: localStorage.getItem('user'),
					ids: this.ids,
					locked: this.lockForm.locked
				};
				batchLocked(data).then(res => {
					if (res?.code === 200) {
						this.getData(); // 重新加载数据
						this.ids = []; // 清空ID数组
						this.multipleSelection = []; // 清空多选状态
						this.lockVisible = false; // 关闭锁定弹窗/状态
						this.$message.success(res.data || '操作成功'); // 成功提示（带默认文案）
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getLock2(row) {
				let data = {
					userId: localStorage.getItem('user'),
					ids: row.id,
					locked: row.locked
				};
				batchLocked(data).then(res => {
					if (res?.code === 200) {
						this.getData();
						this.$message.success(res.data);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog2() {
				this.lockVisible = false;
			},
			handleExport() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					enable: this.query.enable
				};
				downloadCompany(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '企业' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},


			getcompanyRulesSettingList() {
				this.tableData7 = [];
				this.loading = true;
				companyRulesSettingList().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						res.data.forEach(i => {
							i.protectionLevel = String(i.protectionLevel);
							this.tableData7.push(i);
						})
					} else {
						this.$message.error(res.message);
					}
				});
			},
			deleteEdit(row) {
				let data = {
					id: row.id
				}
				deleteRules(data).then(res => {
					if (res?.code === 200) {
						this.getcompanyRulesSettingList();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showEdit(row) {
				this.addEnterpriseLevelVisible = true;
				this.addEnterpriseLevelFormUpdate = true;
				this.addEnterpriseLevelForm = row
			},
			showAddEnterpriseLevelVisible() {
				this.addEnterpriseLevelForm = {
					protectionLevel: '', //电话邦等级
					blacklist: true, //共享黑名单
					riskNumber: true, // 共享风险号码
					highFrequency: true, // 共享风险号码
					yxLevel: '三级', //御鑫等级
					lv: '',
					rules: [{
						use1: {
							value: '',
							type: ""
						},
						use2: {
							value: '',
							type: ""
						},
						complaint: '',
					}]
				}
				this.addEnterpriseLevelVisible = true;
				this.addEnterpriseLevelFormUpdate = false;
			},
			closeEnterpriseLevelDialog() {
				this.addEnterpriseLevelVisible = false;
				this.getcompanyRulesSettingList();
			},
			addDomain() {
				this.addEnterpriseLevelForm.rules.push({
					use1: {
						value: '',
						type: ""
					},
					use2: {
						value: '',
						type: ""
					},
					complaint: '',
				});
			},
			removeDomain(item) {
				if (this.addEnterpriseLevelForm.rules.length > 1) {
					var index = this.addEnterpriseLevelForm.rules.indexOf(item)
					if (index !== -1) {
						this.addEnterpriseLevelForm.rules.splice(index, 1)
					}
				}
			},
			getUpdateEnterpriseLevel() {
				// 定义级别映射关系
				let levelMap = {
					'一级': '1',
					'二级': '2',
					'三级': '3',
					'四级': '4',
					'五级': '5'
				};
				// 使用映射转换级别
				let originalLevel = this.addEnterpriseLevelForm.yxLevel;
				this.addEnterpriseLevelForm.yxLevel = levelMap[originalLevel] || originalLevel;
				this.addEnterpriseLevelForm.protectionLevel = String(this.addEnterpriseLevelForm
					.protectionLevel);
				updateRules(JSON.stringify(this.addEnterpriseLevelForm)).then(res => {
					if (res?.code === 200) {
						this.addEnterpriseLevelVisible = false;
						this.addEnterpriseLevelForm.rules = [{
							use1: {
								value: '',
								type: ""
							},
							use2: {
								value: '',
								type: ""
							},
							complaint: '',
						}]
						this.$message.success(res.data);
						// this.getcompanyRulesSettingList()

					} else {
						this.$message.error(res.message);
					}
				});
			},
			getAddEnterpriseLevel() {
				// 定义级别映射关系
				let levelMap = {
					'一级': '1',
					'二级': '2',
					'三级': '3',
					'四级': '4',
					'五级': '5'
				};
				// 使用映射转换级别
				let originalLevel = this.addEnterpriseLevelForm.yxLevel;
				this.addEnterpriseLevelForm.yxLevel = levelMap[originalLevel] || originalLevel;
				this.addEnterpriseLevelForm.protectionLevel = String(this.addEnterpriseLevelForm
					.protectionLevel);
				addRules(JSON.stringify(this.addEnterpriseLevelForm)).then(res => {
					if (res?.code === 200) {
						this.addEnterpriseLevelVisible = false;
						this.addEnterpriseLevelForm.rules = [{
							use1: {
								value: '',
								type: ""
							},
							use2: {
								value: '',
								type: ""
							},
							complaint: '',
						}];
						this.$message.success(res.data);
					} else {
						this.$message.error(res.message);
					}
				});
			},

			//下载磨板
			getdownloadOutboundTemplate() {
				downloadOutboundTemplate().then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '临时出库模板' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
			getOutboundData() {
				this.loading = true;
				deliveryList(this.query4).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData4 = res.data.list;
						this.pageTotal4 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showFrequencyLimitingVisible() {
				this.frequencyLimitingVisible = true;
			},
			frequencyLimitingClose() {
				this.frequencyLimitingVisible = false;
			},
			frequencyLimitingSet() {
				let data = {
					standard: this.frequencyLimitingForm.standard.join(","),
					num: this.frequencyLimitingForm.num,
				};
				// dxtLimitCall(data).then(res => {
				// 	if (res?.code === 200) {


				// 	} else {
				// 		this.$message.error(res.message);
				// 	}
				// });
			},
			//获取时间
			getTime() {
				// 解构赋值配合条件判断
				const [start, end] = Array.isArray(this.timeArr) && this.timeArr.length === 2 ? [this.toDateTimeStr(this
					.timeArr[0]), this.toDateTimeStr(this.timeArr[1])] : ['', ''];
				// 统一赋值
				[this.query4.startTime, this.query4.endTime] = [start, end];
				// 重置无效的timeArr
				if (!Array.isArray(this.timeArr) || this.timeArr.length !== 2) {
					this.timeArr = [];
				}
			},
			//筛选时间
			getTime2() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr2.push(startTime);
				this.timeArr2.push(endTime);
			},
			toDateTimeStr(nS) {
				const date = new Date(nS);
				return [
					date.getFullYear(),
					(date.getMonth() + 1).toString().padStart(2, '0'),
					date.getDate().toString().padStart(2, '0')
				].join('-');
			},

			//套餐
			getSetMealList() {
				this.query.setMealId = '';
				let data = {
					cardId: this.query.cardId,
				};
				setMealList(data).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//操作人
			getDeliveryOperator() {
				deliveryOperator().then(res => {
					if (res?.code === 200) {
						this.operatorList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//城市
			getDeliveryCity() {
				deliveryCity().then(res => {
					if (res?.code === 200) {
						this.cityList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//弹窗
			showExpressDialog(row) {
				this.dialogVisible = true;
				let data = {
					id: row.id,
				}
				logisticsInquiry(data).then(res => {
					if (res?.code === 200) {
						this.expressData = res.data;
						this.expressData.userData = row;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleClose2() {
				console.log('弹窗已关闭')
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			exportData() {
				deliveryDownload(this.query4).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '出库记录' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
			exportData2() {
				let data = {
					agentId: this.query13.agentId,
					companyId: this.query13.companyId,
					cardsId: this.query13.cardsId,
					standard: this.query13.standard,
					pageIndex: this.query13.pageIndex,
					pageSize: this.query13.pageSize,
					startTime: this.toDateTimeStr(this.timeArr2[0]),
					endTime: this.toDateTimeStr(this.timeArr2[1]),
				}
				activateExport(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '激活明细' + '.xls';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},

			handleAudit(row) {
				this.auditForm.remark = '';
				this.auditForm.enable = true;
				this.auditForm.id = row.id;
				this.auditVisible = true;
			},
			getCompanyAudit() {
				companyAudit(this.auditForm).then(res => {
					if (res?.code === 200) {
						this.auditVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			auditClose() {
				this.auditVisible = false;
			},
			handleauditRecord(row) {
				this.auditRecordVisible = true;
				this.tableData9 = row.auditRecord;
			},

			auditRecordClose() {
				this.tableData9 = [];
				this.auditRecordVisible = false;
			},
			showAddBlackVisible() {
				this.addBlackVisible = true;
				this.addBlackForm.companyNames = '';
				this.addBlackForm.type = '1';
			},
			closeAddBlackDialog() {
				this.addBlackVisible = false;
			},
			getAddCompanyBlacklist() {
				addCompanyBlacklist(this.addBlackForm).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.addBlackVisible = false;
						this.getEnterpriseBlacklist();
					} else {
						this.duplicateBlacklistVisible = true;
						this.duplicateBlacklist = res.data;
						this.$message.error(res.message);
					}
				});
			},
			closeDuplicateBlacklistDialog() {
				this.duplicateBlacklistVisible = false;
			},
			submitUploadAddCompanyBlacklist() {
				if (this.$refs.uploadaddCompanyBlack.uploadFiles[0]) {
					this.loading = true;
					this.$refs.uploadaddCompanyBlack.submit();
					this.getEnterpriseBlacklist();
				} else {
					this.$message.error('请选择上传文件');
				}

			},
			getEnterpriseBlacklist() {
				this.loading = true;
				companyBlacklist(this.query10).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData10 = res.data.list;
						this.pageTotal10 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//导入上传
			uploadaddBlackSuccess(success) {

				setTimeout(() => {
					this.$refs.uploadaddCompanyBlack.clearFiles();
					this.addBlackVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.getEnterpriseBlacklist();
				} else {
					// this.open(success.message);
					this.$message.error(success.message);
				}
			},
			handleDeleteBlackList(index, id) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							id: id,
						};
						deleteBlackList(data).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getEnterpriseBlacklist();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},

			getActivateRecordlist() {

				if (this.timeArr2 === null) {
					this.$message.error('请选择时间');
				} else {
					let data = {
						agentId: this.query12.agentId,
						companyId: this.query12.companyId,
						cardsId: this.query12.cardsId,
						standard: this.query12.standard,
						pageIndex: this.query12.pageIndex,
						pageSize: this.query12.pageSize,
						startTime: this.toDateTimeStr(this.timeArr2[0]),
						endTime: this.toDateTimeStr(this.timeArr2[1]),
					}
					this.loading = true;
					activateRecord(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							this.tableData12 = res.data.list;
							this.pageTota12 = res.data.total;
							const safeCustomData = Array.isArray(res.customData) ? res.customData : [];
							this.activateDataTotal = safeCustomData.reduce((acc, item) => {
								acc.activateCount += item.total || 0; // 额外防止 item.total 未定义
								return acc;
							}, {
								activateCount: 0,
							});
							this.activateList = res.customData ? [...res.customData].reverse() : [];
						} else {
							this.$message.error(res.message);
						}
					});
				}

			},
			getactivateInfo() {
				if (this.timeArr2 === null) {
					this.$message.error('请选择时间');
				} else {
					let data = {
						agentId: this.query13.agentId,
						companyId: this.query13.companyId,
						cardsId: this.query13.cardsId,
						standard: this.query13.standard,
						pageIndex: this.query13.pageIndex,
						pageSize: this.query13.pageSize,
						startTime: this.toDateTimeStr(this.timeArr2[0]),
						endTime: this.toDateTimeStr(this.timeArr2[1]),
					}
					this.loading = true;
					activateInfo(data).then(res => {
						this.loading = false;
						if (res?.code === 200) {
							this.tableData13 = res.data.list;
							this.pageTotal13 = res.data.total;
						} else {
							this.$message.error(res.message);
						}
					});
				}
			},
			getexportWarehouse() {
				let data = {
					province: this.province,
					cardId: this.mapcardsId,
				}
				exportWarehouse(data).then(res => {
					const blob = new Blob([res], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
					});
					let downloadElement = document.createElement('a');
					let href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					let fileName = '出库' + '.xlsx';
					downloadElement.download = fileName;
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				});
			},
			getqueryProvinceCity() {
				this.provinceData = [];
				this.province = '';
				this.mapcardsId = '';
				this.dataList = [];
				let data = {
					province: this.province,
					cardId: this.mapcardsId,
				}
				queryProvinceCity(data).then(res => {
					if (res?.code === 200) {
						this.provinceData = res.data;
						// 排序后的数据用于侧边栏显示
						// let chartData = [...this.provinceData].sort((a, b) => b.value - a.value);
						let chartData = this.provinceData.sort((a, b) => b.value - a.value);
						this.renderDataList(chartData);
						this.initMap();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getqueryProvinceCity2() {
				let data = {
					province: this.province,
					cardId: this.mapcardsId,
				}
				queryProvinceCity(data).then(res => {
					if (res?.code === 200) {
						// this.provinceData = res.data;
						// 排序后的数据用于侧边栏显示
						// let chartData = [...res.data].sort((a, b) => b.value - a.value);
						let chartData = res.data.sort((a, b) => b.value - a.value);
						this.renderDataList(chartData);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getqueryProvinceCity3(item) {
				this.province = item.name;
				let supportedProvinces = new Set([
					'山东省', '福建省', '河南省', '河北省', '湖北省', '湖南省', '江西省', '海南省', '黑龙江省', '陕西省', '贵州省', '江苏省', '安徽省',
					'吉林省', '山西省', '甘肃省', '四川省', '浙江省', '云南省', '辽宁省', '广东省', '青海省', '台湾省', '内蒙古省', '西藏省', '新疆省',
					'宁夏省', '广西省', '北京市', '重庆市', '上海市', '天津市', '香港', '澳门'
				]);
				supportedProvinces.forEach(province => {
					if (this.province == province) {
						let data = {
							province: this.province,
							cardId: this.mapcardsId,
						}
						queryProvinceCity(data).then(res => {
							if (res?.code === 200) {
								this.provinceData = res.data;
								// 排序后的数据用于侧边栏显示
								let chartData = this.provinceData.sort((a, b) => b.value - a.value);
								this.renderDataList(chartData);
								this.initMap();
							} else {
								this.$message.error(res.message);
							}
						});
					}
				});

			},
			async initMap() {
				await this.$nextTick();
				const container = this.$refs.map;
				if (!container) {
					console.error('地图容器不存在');
					return;
				}
				if (this.chart) {
					this.chart.dispose();
					this.chart = null;
				}
				const echarts = require('echarts');
				this.chart = echarts.init(container);
				try {
					// 使用市级地图数据源
					// const response = await fetch('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json');
					const response = await fetch(
						'https://phone-recorder.oss-cn-hangzhou.aliyuncs.com/yunqitongxcx/static/100000_full.json');
					if (!response.ok) throw new Error('地图数据加载失败');
					const chinaGeoJSON = await response.json();
					echarts.registerMap('china', chinaGeoJSON);
					this.setChartOption();
				} catch (error) {
					console.error('地图初始化失败:', error);
				}
			},
			setChartOption() {
				const option = {
					backgroundColor: 'transparent',
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							return `${params.name}<br/>出库量: ${params.value || 0}`;
						},
						backgroundColor: 'rgba(10, 20, 40, 0.9)',
						borderColor: '#2962ff',
						textStyle: {
							color: '#fff',
							fontSize: 14,
						},
					},
					series: [{
						name: '出库量',
						type: 'map',
						map: 'china',
						roam: true,
						scaleLimit: {
							min: 1.25,
							max: 10,
						},
						label: {
							show: true,
							fontSize: 10,
							color: '#000',
						},
						emphasis: {
							label: {
								color: '#fff',
								fontSize: 12,
								fontWeight: 'bold',
							},
							itemStyle: {
								areaColor: '#154e90', //整个地图hover的时候
								borderWidth: 2,
								borderColor: '#154e90',
							}
						},
						data: this.provinceData,
					}]
				};
				// 使用配置项显示图表
				this.chart.setOption(option);

				this.chart.on('click', (params) => {
					this.province = params.name;
					this.dataList = [];
					this.getqueryProvinceCity2();
				});
			},
			renderDataList(data) {
				this.dataList = [];
				this.dataList = data;
			},
			getresetbtn() {
				this.chart.dispatchAction({
					type: 'mapRoam',
					dx: 0,
					dy: 0,
					zoom: 1,
					center: [0, 0]
				});
				this.getqueryProvinceCity();
			},
			getshowdatabtn() {
				let chartData = this.provinceData.sort((a, b) => b.value - a.value);
				this.renderDataList(chartData);
			},
			getrefreshbtn() {
				const loadingElement = document.querySelector('.loading');
				if (loadingElement) {
					loadingElement.style.display = 'block';
				}
				const errorElement = document.querySelector('.error');
				if (errorElement) {
					errorElement.remove();
				}
				// 重新加载地图
				this.initMap();
			},

		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.el-form-item__label {
		font-size: 13px !important;
	}

	.content_top {
		display: flex;
		justify-content: space-around;
	}

	.content_bottom {
		display: flex;
		justify-content: space-around;
	}

	.content_middle {
		display: flex;
		margin: 0.625rem 0 0.625rem 0;
		justify-content: space-around;
	}

	.ywlx:hover {
		color: #00a854;
		background: none;
	}

	.content_top {
		display: flex;
		margin: auto;
	}


	.card-body {
		background: #ffffff;
		border-radius: 16px;
		overflow: hidden;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
	}

	.card-body:hover {
		transform: translateY(-5px);
	}

	.tit {
		padding: 20px 25px;
		color: #ffffff;
		display: flex;
		align-items: center;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}

	.tit div {
		display: flex;
		align-items: center;
		font-size: 1.3rem;
		font-weight: 600;
	}

	.tit i {
		margin-right: 12px;
		font-size: 1.5rem;
	}

	.card-list {
		display: flex;
		flex-wrap: wrap;
		padding: 20px;
		gap: 20px;
	}

	.card-item {
		flex: 1;
		min-width: 280px;
		background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
		border-radius: 12px;
		padding: 25px;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}

	.card-item:hover {
		transform: translateY(-5px);
	}

	.card-list-tit {
		display: block;
		font-size: 1.1rem;
		color: #7f8c8d;
		margin-bottom: 15px;
		font-weight: 600;

	}

	.card-list-data {
		display: block;
		font-size: 2.5rem;
		font-weight: 700;
		color: #2c3e50;
		margin-bottom: 15px;
		transition: all 0.3s ease;
	}

	.card-item:hover .card-list-data {
		color: #4f7afd;
	}

	.operator-item {
		display: flex;
		justify-content: space-between;
		padding: 12px 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	}

	.operator-item:last-child {
		border-bottom: none;
	}

	.operator-label {
		font-size: 1rem;
		color: #34495e;
		font-weight: 500;
	}

	.operator-value {
		font-size: 1.2rem;
		font-weight: 700;
		color: #4f7afd;
	}

	.unicom-operator {
		color: #1dd1a1;
	}

	.telecom-operator {
		color: #4f7afd;
	}

	.stats-summary {
		display: flex;
		justify-content: space-between;
		padding: 25px;
		background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
		border-top: 1px solid rgba(0, 0, 0, 0.05);
	}

	.stat-item {
		text-align: center;
		padding: 0 15px;
	}

	.stat-value {
		font-size: 1.8rem;
		font-weight: 700;
		margin-bottom: 5px;
	}

	.mobile-stat .stat-value {
		color: #ff6b6b;
	}

	.unicom-stat .stat-value {
		color: #1dd1a1;
	}

	.telecom-stat .stat-value {
		color: #4f7afd;
	}

	.stat-label {
		font-size: 1rem;
		color: #7f8c8d;
		font-weight: 600;
	}

	@media (max-width: 768px) {
		.card-list {
			flex-direction: column;
		}

		.stats-summary {
			flex-direction: column;
			gap: 20px;
		}

		.header h1 {
			font-size: 2rem;
		}
	}

	.fade-in {
		animation: fadeIn 0.6s ease forwards;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.card-item:nth-child(1) {
		animation-delay: 0.1s;
	}

	.card-item:nth-child(2) {
		animation-delay: 0.2s;
	}

	.card-item:nth-child(3) {
		animation-delay: 0.3s;
	}

	.card-item:nth-child(4) {
		animation-delay: 0.4s;
	}

	.form-items-wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
	}

	.form-items-wrapper .el-form-item {
		flex: 0 0 auto;
		margin: 5px 10px 5px 0;
		display: flex;
		flex-direction: row;
	}

	/deep/ .handle-box .el-form-item__content {
		margin-left: 0 !important;
	}

	/deep/ .handle-box .el-form-item__label {
		font-size: 14px !important;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}

	#echartsMap {
		width: 100%;
		height: 650px;
		position: relative;
	}

	.loading {
		position: absolute;
		top: 50%;
		left: 35%;
		transform: translate(-50%, -50%);
		text-align: center;
		z-index: 10;
	}

	.loader {
		border: 5px solid #f3f3f3;
		border-top: 5px solid #1890ff;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		margin: 0 auto 20px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}

	.progress-container {
		width: 200px;
		height: 8px;
		background: #e6f7ff;
		border-radius: 4px;
		margin: 0 auto 10px;
		overflow: hidden;
	}

	.progress-bar {
		height: 100%;
		width: 0;
		background: #1890ff;
		border-radius: 4px;
		animation: progress 2s infinite;
	}

	@keyframes progress {
		0% {
			width: 0;
		}

		50% {
			width: 70%;
		}

		100% {
			width: 100%;
		}
	}

	.cache-info {
		color: #8c8c8c;
		font-size: 12px;
	}

	.map-tip {
		height: 30px;
		line-height: 30px;
		text-align: center;
		color: #8c8c8c;
		font-size: 12px;
		background: #f0f0f0;
	}

	.map-container-box {
		margin: 0 auto;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
		color: #fff;
		padding: 20px;
	}

	.header {
		text-align: center;
		margin-bottom: 30px;
		padding: 20px;
		background: #7B9BFD;
		border-radius: 15px;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
	}

	.header h1 {
		font-size: 2.5rem;
		margin-bottom: 10px;
		text-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
		background: linear-gradient(90deg, #ffd700, #ffa500);
		-webkit-background-clip: text;
		background-clip: text;
		color: transparent;
	}

	.header p {
		font-size: 1.2rem;
		opacity: 0.9;
		max-width: 800px;
		margin: 0 auto;
		line-height: 1.6;
	}

	.map-content {
		display: flex;
		gap: 20px;
		flex-wrap: wrap;
		padding: 0 0 20px 0;
	}

	.map-container {
		flex: 1;
		min-width: 300px;
		background: #7B9BFD;
		overflow: hidden;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
		padding: 20px;
	}

	#map {
		width: 100%;
		height: 900px;
		top: 0px;
		overflow: hidden;
	}

	.data-list {
		margin-top: 20px;
		max-height: 715px;
		overflow-y: auto;
		width: 90%;
		padding: 0 5%;
	}

	.sidebar {
		width: 300px;
		border-radius: 15px;
		padding: 20px;
		box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
	}

	.controls {
		display: flex;
		flex-direction: column;
		gap: 15px;
		margin-bottom: 20px;
	}

	.btn {
		/* background: linear-gradient(135deg, #2962ff, #0039cb); */
		border: none;
		color: #ffffff;
		padding: 12px 20px;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.3s;
		font-size: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		margin: 0;
	}

	.btn:hover {
		/* background: linear-gradient(135deg, #0039cb, #2962ff); */
		transform: translateY(-2px);
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
	}

	.btn:active {
		transform: translateY(0);
	}

	.btn i {
		font-size: 1.2rem;
	}

	.data-item {
		display: flex;
		justify-content: space-between;
		padding: 10px;
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		cursor: pointer;
	}

	.data-item:hover {
		background: rgba(255, 255, 255, 0.1);
	}

	.legend {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 15px;
		margin-top: 20px;
		flex-wrap: wrap;
		padding: 15px;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 10px;
	}

	.legend-item {
		display: flex;
		align-items: center;
		gap: 5px;
	}

	.legend-color {
		width: 20px;
		height: 20px;
		border-radius: 3px;
	}

	.footer {
		text-align: center;
		margin-top: 30px;
		opacity: 0.7;
		font-size: 0.9rem;
		padding: 15px;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 10px;
	}

	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		font-size: 1.2rem;
	}

	.error {
		color: #ff6b6b;
		text-align: center;
		padding: 20px;
		background: rgba(255, 107, 107, 0.1);
		border-radius: 10px;
		margin: 10px 0;
	}

	@media (max-width: 768px) {
		.content {
			flex-direction: column;
		}

		.sidebar {
			width: 100%;
		}

		.header h1 {
			font-size: 2rem;
		}

		#map {
			height: 400px;
		}
	}

</style>